// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` body {
  margin: 0;
  font-family: 'Open Sans', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.popup-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  resize: none;
}
.flexrows{
  display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
}
.popup-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  height: 10rem;
}

.header {
  background: #ffffff;
  color: rgb(5, 4, 4);
  padding: 10px;
  text-align: center;
}

.main {
  display: flex;
  flex: 1;
  margin-left: 250px; /* Match the width of the sidebar */
  padding: 1rem;
  height: calc(100vh - 60px); /* Full height minus top banner height */
  overflow-y: auto;
}
 

.content {
  /* flex: 1;
  padding: 20px; */
  /*margin-top: 60px;  Match the height of the top banner */
  margin-left: 250px; /* Match the width of the sidebar */
  padding: 1rem;
  height: calc(100vh - 60px); /* Full height minus top banner height */
  overflow-y: auto;
}

.sidebar {

  height: 100vh;
  position: fixed;
  z-index: 1;
 
}
.back-to-list {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.custom-button {
  padding: 15px 30px;
  background-color: #5A9BD5;
  color: white;
  border: none;
  border-radius: 35px;
  cursor: pointer;
}
.save-button {
  padding: .375rem 25px;
  background-color: #1A4D8F !important;
  color: white;
  border: none;
    border-radius: 100px;
    cursor: pointer !important;
    height: 38px;
    font-size: 16px;
}
.saveButton:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }
.input-field {
  height: 52px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.back-icon {
  width: 16px;
  height: 16px;
}

/* Top Banner */
.top-banner {
  position: fixed;
  top: 0;
  left: 250px; /* Match the width of the sidebar */
  right: 0;
  height: 60px;
  z-index: 1000;
}

/* Content Area */
.content-area {
  /* margin-top: 15px; Match the height of the top banner */
  margin-left: 270px;  /* Match the width of the sidebar */
  padding: 2.5rem 1.7rem;
  height: calc(100vh - 60px); /* Full height minus top banner height */
  position: relative;
      background: #fafafa !important;

  /* overflow-y: auto; */
}

.subtypes {
  padding: 20px;
}

.subtypes-header {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
}

.subtypes-container {
  border: 1px solid #ccc;
  padding: 20px 30px;
  background-color: #fff;
  margin: 20px 0px;
  height:auto;
  width: 100%;
}

.leftBorder {
  font-size: 24px;
    color: #323232;
    font-weight: 700;
    text-transform: uppercase;
    border-left: 3px solid #ED6C00;
    padding: 0 0 0 5px;
    line-height: 25px;
  }

  .headingbold {
    font-weight: 700;
    text-transform:none !important;
  }

.subtypes-title {
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: bold;
  color: #000000;
}

.add-item-button {
  float: right;
  background-color: #fff;
  color: #FF0000;
  padding: 8px 12px;
  border: 2px solid #FF0000;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
  display: flex;
}

.add-item-button:hover {
  background-color: #f4c2c2;
}

.subtypes-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 30px;
  color: #1F5186;
}

.table-content {
  /* width: 100%; */
  border-collapse: collapse;
  margin-top: 30px;
  color: black;
}
.actionClass{
  width: 12%;
}
.sett th,
.sett td {
   border: 1px solid #ccc !important; 
  /* text-align: justify;  */
  padding: 14px 15px;
}


.table .table-striped th,
.table .table-striped td {
   /* border: 1px solid #ccc;  */
  /* text-align: justify;  */
  border: none !important;
  padding: 14px 15px;
}


.table thead tr{
color: #323232 !important;
}

.table tbody td{
  font-size: 15px;
  font-weight: 400;
color: #323232 !important;
}
.subtypes-table th {
font-weight: 700 !important;
}

.subtypes-table th {
  background-color: #f2f2f2;
}

.subtypes-table.table-striped tbody tr:hover {
  background-color: #e0f7fa !important; /* Override Bootstrap */
  cursor: pointer; /* Optional: shows pointer */
}
.actions {
  display: flex;
  border: 1px;
}

.fontsize {
  font-size: 25px;
  font-weight: 700;
}

.action-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0 !important;
}

.action-btn:hover {
  color: #007bff;
}
.centerAlign{
  text-align: center !important;
}
.actionButtons{
  display: flex;
  gap: 15px;
  align-items: center;
}
.actionIcons{
  width: 18px;
  height: 18px;
}
.actionIconsLt{
  width: 15px;
  height: 15px;
}
.ml-10{
  margin-left: 10px;
}
.rightAligned{
  text-align: right !important;
}
.withoutBorderButton{
  border: none;
    background: #ffff;
    padding-left: 0px;
}

.logoset_main{
  width:120px;
}
.logoset1{
  width: 100%;
}

.leftside_hide{
  display: none;
}
.search-btn {
  background: #EEEEEE;
  border: 1px solid #e0e0e0;
  color: #323232;
  font-size: 16px;
  font-weight: 600;
  max-width: 100%;
  margin: 0 0 0 20px;
  box-shadow: none;
  transition: all 0.2s ease-in-out;
  font-family: inherit;
}

.search-btn:hover {
  background-color: #ccc;
  color: white;
  border: 1px solid #054772;
  cursor: pointer;
}
.search-button:hover {
  border: 1px solid #ccc !important;
}
@media (min-width: 1450px ) {
  .search-btn {
    width: auto;
  }
}

.search-bar.rightfloat {
  /* width: 50%; */
  float: right;
}
.rightfloat .form-control{
  font-size: 12px !important;
}
.entries-selector {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 13px;
}

select#entries-select {
  width: 62px;
  font-size: 14px;
}
.newselect select#entries-select {
  flex: none;
  width: 30%;
  background-size: 14px 16px; 
}
.newselect .form-select{
  min-height: 38px !important;
}
.pagination-container {
  text-align: center;
}


.pagination-btn {
  padding: 5px 15px;
  /* margin: 0 5px; */
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  font-size: 12px;
}

.pagination-btn.active {
  background-color: #007bff;
  color: #fff;
}
button#pending-approval-search-btn {
  font-weight: 700;
}
.pagination-btn:disabled {
  cursor: not-allowed;
  background-color: #e9ecef;
  pointer-events: none;
  opacity: 0.5; /* Optional: Makes the button look disabled */
}
.scroll{
  overflow-y: auto;
  padding-bottom: 25% !important;
  scrollbar-color: #1f5186 #1f5186;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.dflexcheckbox{
  display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.dflexAdbUtoon{
 display: flex;
 gap: 5px; 
}



.flexRequestTitle{
  display: flex !important;
    flex-direction: row;
    justify-content: space-between;
}

.outerPlacehoder{
  text-align: right;
  font-size: 10px;
  font-weight: 400;
  color: #808080;
}
.alignright{
      text-align-last: end;
    float: right;
}

.approverPositions{
  color: rgb(128, 128, 128);
    text-align: left;
    font-size: 10px;
    font-weight: 400;
}
.attachmentList{
  border: 0;
    font-weight: bold;
    background-color: #f9f9f987 !important;
}

.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: .25rem;
}
.list-group-item:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.floatLeft{
  float: left;
}


.action-by {
  font-weight: bold;
}
.subtext {
  color: gray;
  font-size: 12px;
}
.readValues{
  text-align: left;
    font-size: 14px !important;
    color: #323232;
    font-weight: 600;
}
.mar{
  margin-bottom: 0px;
  font-weight: 600;
}
.pspan{
  color: rgb(128, 128, 128);
  text-align: left;
  font-weight: 400;
  padding: 0px 0px 0px 12px;
  font-size: 10px !important;
  float: left;
  width: 100%;;
}

.pspanread{
  float: left;
  width: 100%;;
}

.loader-container-req {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; /* Full page loader */
}

.spinner-req {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* .file-list {
  margin-top: 10px;
} */

.bgBottom{
  border-top: none !important;
  border-bottom: 1px solid #ccc !important;
}
.imgIcon{
  width: 100%;
  float: left;
}
.imgModalH{
     height: 15vh;
}
.bgRight{
      border-right: 2px solid #ccc;
}
.fileNameModal{
      padding: 5px !important;
    font-size: 11px !important;
    text-align: left;
}
.newModalButton{
  padding: 8px !important;
    font-size: 6px !important;
    top: 3px !important;
}
.scrollModal{
  overflow-y: auto;
    max-height: 60vh;
}
.emailTypeLogo{
  width: 92%;
}
.file-item {
  display: flex;
  justify-content: space-between;
  background: #F7F7F7;
  padding: 6px 8px;
  border-radius: 5px;
  margin: 0px 0px 8px 0px;
  font-size: 14px;
  font-weight: 600;
  color: #ff585d;
  cursor: pointer  !important;
  /* max-width: 350px;  Fixed width */
  /* overflow: hidden; */
  /* white-space: nowrap; */
  /* text-overflow: ellipsis; */
  position: relative;
  float:left;
  margin-right: 10px;
}


.parentUpload .col-md-3{
        flex: 0 0 auto;
        /* width: 20% */
    }

    .parentUploadread .col-md-3{
        flex: 0 0 auto;
        width: 20%
    }

.parentUploadnew .col-md-4{
        flex: 0 0 auto;
        /* width: 25.333333%; */
    }


/* a.fileName.visited,
a.fileName.visited:visited {
    color: #ff585d !important;
    text-decoration: none !important;
} */
a.fileName:visited {
    color: #ff585d !important;
    text-decoration: none !important;
}

a.fileName:hover,
a.fileName:focus,
a.fileName:active {
  color: #1564B7 !important;
  /* text-decoration: underline !important; */
  outline: none;
}
a.fileName:hover{
  text-decoration: underline !important;
}
a.fileName{
  color: #1564B7;
  cursor: pointer  !important;
  text-decoration: auto;
  /* overflow: hidden; */
  white-space: nowrap;
  text-overflow: ellipsis;
      font-size: 14px;
  /* max-width: 180px;  Ensures the text truncates */
  /* display: inline-block; */
}
.file-item:hover .tooltip {
  display: block;
}

.tooltip {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 0;
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 12px;
  z-index: 10;
}
.file-item:hover {
  color: #1564B7;
  outline: none;
}
.file-item:not([data-has-id="true"]):hover {
  color: #ff585d; /* Keeps default text color */
  cursor: default !important; /* Prevents pointer cursor */
}

.removeButton {
  background: #f7f7f7;
  color: white;
  border: none;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 8px;
}


span.chip.false.false {
  background: rgb(230 230 230);
  border-radius: 3px;
  color: rgb(51 51 51);
  height: 30px;
}
img.icon_cancel.closeIcon {
  filter: brightness(0.2) !important;
}

li.option.highlightOption.highlight {
    background: #ffff !important;
    color: #000 !important;
}
li.option.highlightOption.highlight:hover {
  background: #accee4 !important;

}
.dotsDisable{
  background: #ffff !important;
    cursor: no-drop !important;
    font-size: 12px;
    color: #000;
}

.react-datepicker__header {
    padding: 0px !important;
    background-color: #fff !important;
}
h2.react-datepicker__current-month {
    padding: 6px !important;
    margin: 3px !important;
    background: #f0f0f0 !important;
    border-radius: 3px !important;
    border: 1px solid #3333;
}
/* button.react-datepicker__navigation.react-datepicker__navigation--next {
    background: grey;
    border-radius: 50px;
    width: 15px;
    height: 15px;
    position: absolute;
    top: 11px;
    right: 18px;
}
button.react-datepicker__navigation.react-datepicker__navigation--previous {
    background: grey;
    border-radius: 50px;
    width: 15px;
    height: 15px;
    position: absolute;
    top: 11px;
    left: 18px;
} */
span.react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous, 
span.react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {
    left: 0px;
}
.react-datepicker__navigation-icon::before, .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow{

  border-color: #000 !important;
}
.react-datepicker__navigation-icon--previous, .react-datepicker__navigation-icon--next {
    right: -3px !important;
    top: 0px !important;
}
/* .react-datepicker__navigation-icon {
    position: relative;
    top: 3px;
    font-size: 20px;
    width: 22px;
    background: #ff0000 !important;
    border-radius: 50px !important;
} */
.react-datepicker__header{
  border: none !important;
}
.react-datepicker__day--today {
    border: 1px solid #dad55e !important;
    background: #fffa90 !important;
    /* color: #777620 !important; */
    border-radius: 0px !important;
}
.react-datepicker__day--keyboard-selected {
    border-radius: 0px !important;
}
/* .react-datepicker__day--keyboard-selected {
    border: 1px solid #003eff !important;
    background: #007fff !important;
    font-weight: normal !important;
    color: #ffffff !important;
    border-radius: 0px !important;
} */
.react-datepicker__day {
    border: 1px solid #c5c5c5;
    background: #f6f6f6;
    font-weight: normal;
    color: #454545 ; 
    border-radius: 0px !important;
    height: 25px;
    width: 30px !important;
    margin: 2px !important;
}
.react-datepicker__navigation-icon::before, .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow {
    border-width: 2px 2px 0 0 !important; 
    height: 7px !important;
    top: 8px !important;
    width: 7px !important;
}
.react-datepicker__day-name {
    font-weight: bold;
    width: 29px !important;
}
.react-datepicker__month{
  margin: 7px 2px 2px 2px !important;
}
.react-datepicker__day--outside-month, .react-datepicker__day--outside-month:hover{
    color: white !important;
    border: none !important;
    background: none !important;
    cursor: default;
    pointer-events: none !important;
}
.adv-search-css {
  color: #ff585d !important;
}
.adv-search-css:focus, .adv-search-css:hover, .adv-search-css:active {
    color: #1564B7 !important;
    outline: none;
}
.date-picker-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.date-input {
  width: 100%;
  padding-right: 35px; /* Make space for the icon */
}

.calendar-icon {
  position: absolute;
  right: 3%;
    top: 50%;
  transform: translateY(-50%);
  color: #555;
  cursor: pointer;
  
}

.calendar-iconnew{
      position: absolute;
    top: 45%;
    right: 20px;
    transform: translateY(-50%);
    font-size: 20px;
    color: #555;
      cursor: pointer;

}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.fetch-loader-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}

.fetch-loader {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(0, 0, 0, 0.3);
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.cpunterLoader{
  color: #ffff;
  font-size: 10px;
}
.hh{
  height: 32px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.row.mt-3.overflowScroll {
  overflow-x: auto;
}
.searchWrapper{
  overflow-x: auto;
}
.form-check{
  justify-content: center;
  display: flex !important;
  align-items: center;
}

.ql-container.ql-snow {
  min-height: 100px;
  resize: vertical;
  overflow: auto;
  font-size: 14px !important;
  font-family: 'Open Sans', sans-serif !important;
}

#toolbar .ql-style::before {
  content: "\\2728"; /* Unicode sparkle/magic wand icon */
  padding-right: 4px;
}

/* Add similar CSS for each font you define */

.ql-font-arial { font-family: Arial, sans-serif; }
.ql-font-comic-sans { font-family: "Comic Sans MS", cursive; }
/* desktop */
@media screen and (min-device-width: 1024px) and (max-device-width: 1366px) { 
  .content-area {
     margin-left: 270px; 
  }
  .flexrowsRow1{
    width: 25%;
  }
  .flexrowsRow2{
    width: 21%;
  }
  .flexrowsRow3{
    width: 20%;
  }
  .flexrowsRow15 {
width: 10%;
  }
  
    .calendar-iconnew{      
    right: 5px;
    font-size: 16px;

}
.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}

}

/* Tab */
@media screen and (min-device-width: 767px) and (max-device-width: 1023px) { 
  
  nav.navbar.navbar-expand-lg.navbar-light.bg-light.fixed-top .container-fluid h2 {
   font-size: 16px;
}

/* .content-area {
  margin-left: 70px !important;
} */
.emailTypeLogo{
  width: 80px;
  height: 80px;
}
}

@media screen and (min-device-width: 1024px) and (max-device-width: 991px) { 

.emailTypeLogo{
  width: 100px;
  height: 100px;
}
}

@media (max-width: 992px) {
.emailTypeLogo{
display: none;
}
}

/* mobile View */
@media screen and (min-device-width: 481px) and (max-device-width: 991px) { 
  
  nav.navbar.navbar-expand-lg.navbar-light.bg-light.fixed-top .container-fluid h2 {
    display: none;
}
.actionClass{
  width: 20%;
}
/* .sidebar {
  width: 60px !important;
} */
.sidebar-expanded {
  width: 240px !important;
}

/* .content-area {
  margin-left: 70px !important;
} */
input.inputType {
  margin-bottom: 10px;
}
.saveButton, .save-button {
  padding: 8px 20px;
  font-size: 13px;
}
.cancelButton {
  padding: 8px 20px;
  font-size: 13px;
}
.dflexcheckbox{
  display: block;
}
.emailTypeLogo{
 display: none;
}
.oneD{
  display: flex;
  flex-direction: column !important;
 }
/* .onSmallScreen{
  position: absolute;
    right: 0px;
 } */
 /* .onSmallScreen{
  position: absolute;
    right: 0px;
 } */
    .calendar-iconnew{      
    right: 5px;
    font-size: 16px;

}
.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}
.BoxDeligate{
  width: fit-content;
  min-width: 170px !important;
}

}

@media screen and (min-device-width: 763px) and (max-device-width: 991px) { 
 button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    position: absolute;
    right: 60px;
}
    .header-bg h1 {
      padding-right: 100px !important;
    }
    .calendar-iconnew{      
    right: 5px;
    font-size: 16px;

}
.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}
}

@media screen and (min-device-width: 679px) and (max-device-width: 762px) { 
 button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    position: absolute;
    right: 60px;
}
    .header-bg h1 {
      padding-right: 90px !important;
    }
    .calendar-iconnew{      
    right: 5px;
    font-size: 16px;

}
.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}
}

/* @media screen and (min-device-width: 751px) and (max-device-width: 991px) { 
 button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    position: absolute;
    right: 60px;
}
} */
/* @media screen and (max-device-width: 1024px){
.emailTypeLogo{
 display: none !important;
}
} */


@media screen and (min-device-width: 320px) and (max-device-width: 1023px) { 

  .leftside_hide{
    display: block;
  }
  
  /* button.btn.btn-sm.btn-outline-light{
    display: none;
  } */
    .calendar-iconnew{      
    right: 5px;
    font-size: 16px;

}
.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}
}


@media screen and (min-device-width: 130px) and (max-device-width: 469px) {
  nav.navbar.navbar-expand-lg.navbar-light.bg-light.fixed-top .container-fluid h2 {
    display: none;
}
.newResponsive .col{flex: auto;}
.positionForXLSV{
  position: absolute;
  right: 60px;
  top: 225px;
  margin-top: 1px;
}
.positionForCSV{
  position: absolute;
  right: 30px;
  top: 225px;
  margin-top: 1px;
}
.searchsm{
  height:31px;
}
.subtypes-container {
  padding: 20px 20px !important;
}
/* .content-area {
  margin-left: 70px !important;
} */
/* .subtypes-container { //in case of
  width: 250px;
} */
/* button.add-item-button {
  margin-left: 30px;
  width: 100%;
} */
.rightfloat {
  float: left;
  margin-top: 12px;
}

.pagination-btn {
  padding: 5px 10px;
  margin: 0 2px;
}

.pagination-container.mt-4 {
  font-size: 12px;
  overflow-x: auto;
}

input.inputType {
  margin-bottom: 10px;
}
.saveButton, .save-button {
  padding: 8px 20px;
  font-size: 13px;
}
.cancelButton {
  padding: 8px 20px;
  font-size: 13px;
}
.dflexcheckbox{
  display: flex;
        flex-direction: row;
        justify-content: space-between;
}
.fontTitle {
  margin-top: 10px;
}
.disabled-btn {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}
.disabled-tab {
  pointer-events: none;
  opacity: 0.6;
}

.disabled-link {
    pointer-events: none !important;
  cursor: no-drop !important;
}
.disabled-tabs {
  pointer-events: none;
  opacity: 0.6;
}
.flexrowsRow1{
  width: 100%;
}
.flexrowsRow2{
  width: 100%;
}
.flexrowsRow3{
  width: 100%;
}
.margin0Small{
  margin:0 !important;
}
.flexrowsRow15{
  margin-top: 20px;
}
.flexrowsRow4 {
  margin-top: 20px;
}
.emailTypeLogo{
  display: none;
 }
 .oneD{
  display: flex;
  flex-direction: column !important;
 }
 h6.text-3xl.font-bold {
  font-size: 10px;
}
h5.text-3xl.font-bold {
  font-size: 17px;
}
.d-lg-none{
  position: absolute;
    right: 0px;
}
button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    position: absolute;
    right: 30px;
}
    .calendar-iconnew{      
    right: 5px;
    font-size: 16px;

}
.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}
}





.no-records-container {
  text-align: center;
  padding: 20px;
}

.no-records-image {
  width: 150px;
  height: auto;
  margin-bottom: 10px;
}

.no-records-container p {
  font-size: 16px;
  color: #888;
}
.fileDownload{
  cursor: "pointer"; width: "24px"; height: "24px" 
}

.disabled-btn {
  color: #888; /* Gray text color */
  cursor: not-allowed; /* Change cursor to not-allowed */
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.6); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Ensures it appears above all other elements */
}

.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/*******************\\
  Loading Roller
\\*******************/

@keyframes lds-roller {
  0% {
      transform: rotate(0deg);
  }

  100% {
      transform: rotate(360deg);
  }
}

.BoxDeligate{
  width: fit-content;
  min-width: 170px;
}
.lds-roller {
  position: relative;
  display: inline-block;
  height: 64px;
  width: 64px;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
  position: absolute;
}

.lds-roller div:after {
  position: absolute;
  display: block;
  background: #00539f;
  border-radius: 50%;
  content: " ";
  height: 6px;
  width: 6px;
}

/* Adjust positions for child divs */
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}

.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}

.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}

.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}

.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}

.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}

.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}

.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}


button.navbar-toggler:hover {
  border-color: #ff585d;
  background-color: #ffdedf;
  background-color: #ffdedf;
  outline: none;
}

button.navbar-toggler:active {
  border-color: #9678d3;
  background-color: #ff585d;
  background-color: #ff585d;
}
/* .
m3t-container {
  line-height: 2.5;
} */
 .fitwidth{
  width: fit-content;
 }
 .min180{
  min-width: 180px !important;
 }
 .css-13cymwt-control {
  min-height: 33px !important;
  border: 1px solid #dee2e6 !important;
 }
 .noncheck .custom-select__control {
    min-width: 170px !important;
    min-height: 38px;
    height: 38px;

}
 .css-1xc3v61-indicatorContainer {
  padding: 6px !important;
 }
 .css-19bb58m {
  margin: 0px !important;
 }
 .css-t3ipsp-control{
    min-height: 33px !important;
 }
 .css-15lsz6c-indicatorContainer{
   padding: 6px !important;
 }
 .inTable{
      padding-top: 0px !important;
    padding-bottom: 0px !important;
    font-size: 12px !important;
 }
 .css-1jqq78o-placeholder{
  font-size: 14px !important;
 }
 .form-control{
  font-size: 1rem;
 }
 .form-select{
  font-size: 16px !important;
  min-height: 33px !important;
  background-size: 14px 16px;
}
.paddingleft{
  padding: .75rem !important;
}
.form-selectnew {
    /* --bs-form-select-bg-img: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e); */
    display: block;
    width: 100%;
    padding: .375rem 2.25rem .375rem .75rem !important;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--bs-body-color);
    -webkit-appearance: inline;
    -moz-appearance: inline;
    appearance: inline;
    background-color: var(--bs-body-bg);
    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      background-size: 14px 16px;

}

.form-selectnew1 {
 display: block;
    width: 100%;
    padding: .375rem 1.25rem .375rem .75rem !important;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--bs-body-color);
    -webkit-appearance: inline;
    -moz-appearance: inline;
    appearance: inline;
    background-color: var(--bs-body-bg);
    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 12px;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      background-size: 14px 16px;
}
.borderBlack{
  border: 1px solid #000000 !important;
}


 .pinkshade .css-3iigni-container{}
.BoxDeligate .css-1r977u7-control{}

::placeholder{ color:#717171 !important}
.newRow{
      background-color: transparent;
    font-size: 12px;
    border: 1px solid #ff0000;
    border-radius: 4px;
    color: #ff0000;
}
.lefty{
  float: left;
  margin-right: 15px;
  white-space: nowrap;
}
.fields-table tr td input[type="number"]::-webkit-outer-spin-button,
.fields-table tr td input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.fields-table tr td input,select,textarea{
  padding-left: 1px !important;
}
 .bgTable{
  border: 1px solid #cccc;
 }
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* very high */
}
.react-datepicker-wrapper {
 width: 100% !important;
}
.modal-content {
  background: white;
  padding: 20px 30px;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  text-align: center;
}
.modal-overlay {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
.excRate{
  float: left !important;
    width: 100%;
}
.exRight{
  float: right !important; 
}
.exLeft{
  margin-left:10px
}
.excRateflex{
  display: flex;
  gap: 10px;
}
.exTableLoad{
  margin-left: 20%
}

.loader-container-excel {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.excel-loader {
  width: 24px;
  height: 24px;
  border: 2px solid #ccc;
  border-top: 2px solid #007bff; /* blue spinner */
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.table.fields-table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}



/* Resizer handle styling */
.rc-handle-container {
  position: relative;
}

.rc-handle {
  position: absolute;
  width: 7px;
  cursor: col-resize;
  z-index: 10;
}

.rc-handle:hover {
  background-color: #007bff;
  opacity: 0.5;
}

/* Make sure table cells don't overflow */
.table.fields-table td,
.table.fields-table th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table.vm td {
vertical-align: middle !important;
}

.table-responsive{
  overflow: hidden ;
  position: 'relative'
}

@media (max-width: 768px ) {
.table.fields-table {
    table-layout: auto !important;
}

.table-responsive{
  overflow: auto !important;
}
}
.cursorPointer{
  cursor: pointer;
}
.withoutborder{
  border: 0 !important;
}
.totalsValue{
  text-align: right;
    margin: 5px;
}
.table.fields-table td input[type="number"] {
    text-align: right;
    padding-right: 5px;
}

.mt-30em{
    margin-top: 0.3rem !important;
}

.select__option {
  white-space: pre-wrap; /* preserves \\n line breaks */
  line-height: 1.2;
}

.select__option::after {
  font-size: 4px;
  color: #666;
}
.selectedBadge{
  line-height: 20px;
}
.select__multi-value, .css-a7jxaq-multiValue {
background-color: transparent !important;
}
.css-1wy0on6{
  display: none !important;
}


.css-3iigni-container{
    border-radius: 4px;
    background-color: #ffffff !important;
        border: 1px solid #ced4da;
        padding: 0px;
}
.css-16xfy0z-control{
  min-height: auto !important;
    height: 35px;
    background-color: #ffdedf !important;
}
.css-snjzhi-control{
      border: 3px solid #ffffff !important;
      min-width: 180px !important;
}
.css-snjzhi-control_0{
      border: 0px solid #ffffff !important;
}
.customDropdown{
  color: rgb(0, 0, 0);
  font-size: 14px;
    font-weight: 400;
    background-color: #cccccc !important;
    text-align: left;
    border-radius: 15px;
}
.select__multi-value__remove{
    display: none !important;
}
.listingNameDiv{
   display: flex;
        align-items: center;
        background: rgb(204, 204, 204);
        border-radius: 9999px;
        gap: 8px;
        z-index: 100;
        padding: 2px 5px 2px 2px;
        align-items: center;
        flex-wrap: wrap;
}
.listingNameDivOutOfOffice{
   display: flex;
        align-items: center;
        background: rgb(204, 204, 204);
        border-radius: 9999px;
        gap: 8px;
        /* z-index: 100; */
        padding:2px 5px -1px 2px;
        align-items: center;
        /* flex-wrap: wrap; */

}
.css-1mkvw8y{
  margin: 0 !important;
}
@media screen and (min-device-width: 990px) and (max-device-width: 1111px) { 
    .listingNameDiv {
         font-size: 11px;
    }

    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    right: 25px;
    position: relative;
}

}
@media screen and (min-device-width: 990px) and (max-device-width: 1111px) { 
    .listingNameDivOutOfOffice {
         font-size: 10px;
    }

    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    right: 25px;
    position: relative;
}

}

@media screen and (min-device-width: 768px) and (max-device-width: 1286px) { 
    .listingNameDivOutOfOffice {
         font-size: 10px;
    }

    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    right: 25px;
    position: relative;
}

}
@media screen and (min-device-width: 991px) and (max-device-width: 1190px) { 
    .listingNameDivOutOfOffice {
         font-size: 6px;
    }

    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    right: 25px;
    position: relative;
}

}
@media (max-width: 991px ) {
/* .dashboard-header{
    display: inline-block !important;
} */
}
/* .select__input-container.css-19bb58m {
    height: 0px;
    padding-top: 0px;
} */

.badge-name:hover {
  color: rgb(26, 0, 93); /* Example: Change text color on hover */
}

.badge-clear:hover {
     color: rgb(255, 158, 27) !important;
    background: rgb(255, 88, 93) !important;
  border-radius: 50%;
}

@media screen and (min-device-width: 453px) and (max-device-width: 582px) { 
    .header-bg h1 {
     padding-right: 20px !important;
    }

    /* button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    right: 25px;
    position: relative;
} */

}


@media screen and (min-device-width: 453px) and (max-device-width: 477px) { 
    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    left: 250px;
    position: relative;
}
.newResponsive .col{flex: auto;}
.BoxDeligate {
    width: fit-content;
    min-width: 100%;
}
.fitwidth{
  width: auto;
 }

}

@media screen and (min-device-width: 478px) and (max-device-width: 487px) { 
    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
    left: 250px;
    position: relative;
}
.newResponsive .col{flex: auto;}
.BoxDeligate {
    width: fit-content;
    min-width: 100%;
}

.fitwidth{
  width: auto;
 }
}

@media screen and (min-device-width: 451px) and (max-device-width: 950px) { 
  .navbar-menu-wrapper.d-flex.align-items-center.hamburger.onSmallerOnly {
    /* position: relative; */
    right: 50px !important;
}


}
@media screen and (max-device-width: 450px){ .BoxDeligate {
    width: fit-content;
    min-width: 100%;
}

.fitwidth{
  width: auto;
 }
}
@media screen and (max-device-width: 575px){.BoxDeligate {min-width:100%} .fitwidth{
  width: auto;
 }

}
@media screen and (min-device-width: 583px) and (max-device-width: 762px) { 
    .header-bg h1 {
     padding-right: 90px !important;
    }
    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {
      position: relative;
    right: 50px;
    }
}

@media (max-width: 991px) {
.navbar.default-layout .navbar-menu-wrapper {
position: relative;
right: 50px;
}
}

.dashboard-header.flex {
    DISPLAY: FLEX;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1px;
}
.basic-single-select.active-underline .select__control {
  border-bottom: 2px solid #007bff; /* Your desired underline color */
  border-radius: 0;
}

.css-9x5mqu {
    padding: 2px 10px !important;
    font-size: 12px !important;
}
.basic-single-select .select__control {
  box-shadow: none !important;
  border-color: #ccc !important;
}
.basic-single-select .select__control {
  cursor: pointer;
  border-radius: 4px; /* Your existing radius */
  font-size: 14px;
}

.select__option--is-focused {
  background-color: rgb(255, 88, 93) !important;
  color: #000;
}

.basic-single-select.active-underline .select__control {
  border-bottom: 2px solid #007bff;
  border-radius: 0;
}
.uploadButton:disabled {
  cursor: no-drop;
  opacity: 0.6; /* Optional for visual feedback */
}
.uploadButton{
  max-height: 40px;
}
.textalignRight{
  text-align: right !important;
}

.resizable-quill .ql-editor {
  min-height: 150px;
  /* max-height: 500px; */
  resize: vertical;
  overflow: auto;
}

.readValues img {
  /* width: 100%; */
  max-width: 100%;
  height: auto;
  display: block;
}

.flexjsutify{
  display: flex;
    justify-content: space-between;
}
.descriptiontexterror{
      color: red;
}

.noDataAlign{
  text-align: center !important;
}



/* @media (max-width: 768px ) {
.fileListMB3{
  margin-bottom: 1rem !important;
}
}

@media screen and (min-device-width: 769px) and (max-device-width: 1200px) { 
  .fileListMT2 {
    margin-top: 0.5rem !important;
  }
} */

@media (min-width: 1400px) {
 .advInsider{
        max-width: 1140px !important;
 }

}
@media (min-width: 1200px) {
 .advInsider{
        max-width: 1140px !important;
 }
}

.row.mt-3.mb-3.parentUploadnew {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
}

.fileListMB3 {
    width: auto !important;
    float: left;
    display: flex;
}

.file-list.fileListMT2.pl-0 {
    width: 70%;
    float: left;
}

@media (max-width: 690px) {
 .row.mt-3.mb-3.parentUploadnew{

       flex-wrap: wrap !important;
 }
}

@media (max-width: 690px) {
  .fileListMT2 {
    margin-top: 1rem !important;
    margin-left: 10px !important;
  }
} 

/* 1) Make the control allow overflow (so native tooltips can show) */
.custom-select__control {
  overflow: visible !important;
}

/* 2) Put single‑value and input into their own columns so they don’t overlap */
.custom-select__value-container--has-value {
  display: grid !important;
  grid-template-columns: auto 1fr auto !important;
  align-items: center !important;
}

/* 3) Place your badge in column #1 */
.custom-select__single-value {
  grid-area: 1 / 1 / 2 / 2 !important;
  overflow: visible !important;
}

/* 4) Push the input into column #2 so it no longer sits on top of your badge */
/* .custom-select__input-container {
  grid-area: 1 / 2 / 2 / 3 !important;
} */

/* 5) (Optional) make the input click‑through when not focused,
      so badge clicks still go to the control wrapper */
.custom-select__input-container:not(:focus-within) {
  pointer-events: none !important;
}


.headingsReadable h6{
  font-size: 0.67em !important;
}

.headingsReadable h5{
  font-size: 0.83em !important;
}

.headingsReadable h4{
  font-size: 1em !important;
}

.headingsReadable h3{
  font-size: 1.17em !important;
}
.headingsReadable h2{
  font-size: 1.5em !important;
}
.headingsReadable h1{
  font-size: 2em !important;
}



/* html, body {

} */

@media (max-width: 980px) {
  html, body {
     height: 100%;
  margin: 0;
  min-width: 980px !important;
  padding: 0;
  }
  .mainStartPanel {
    margin-bottom: 100px;
    float: left;
    width: 100%;
}

}
@media (min-width: 980px) {
  .subtypes-table td {
    padding: 10px 15px;
  }
  
 
}
body {
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1; /* Take remaining height */
  min-height: calc(100vh - 100px); /* Adjust based on header/footer */
}
.table-responsive {
  width: 100%;
}

.subtypes-table {
  width: 100% !important;
  table-layout: auto !important;   /* or fixed if you want equal columns */
}

.padStriped{
  padding: 15px 10px 15px 10px !important;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-striped-bg: #f9f9f9;
}

.subtypes-table thead, .subtypes-table tbody {
  width: 100%;
}
table.dataTable.row-border > tbody > tr > th, table.dataTable.row-border > tbody > tr > td, table.dataTable.display > tbody > tr > th, table.dataTable.display > tbody > tr > td {
   border-top: none !important; 
}
/* table headewidth*/
#tab-pending-approvals th:nth-child(1) {
 
  width:10%;
  white-space: nowrap;
}
#tab-pending-approvals th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tab-pending-approvals th:nth-child(3) {
 
  width:20%;
  white-space: nowrap;
}
#tab-pending-approvals th:nth-child(4) {
width:20%;
  white-space: nowrap;
}
#tab-pending-approvals th:nth-child(5) {
 
  width:10%;
  white-space: nowrap;
}
#tab-pending-approvals th:nth-child(6) {
width:30%;
  white-space: nowrap;
}



/* Resubmission */
#tab-resubmission th:nth-child(1) {
 
  width:10%;
  white-space: nowrap;
}
#tab-resubmission th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tab-resubmission th:nth-child(3) {
 
  width:15%;
  white-space: nowrap;
}
#tab-resubmission th:nth-child(4) {
width:15%;
  white-space: nowrap;
}
#tab-resubmission th:nth-child(5) {
width:30%;
  white-space: nowrap;
}



 /* Drafts */
#tab-drafts th:nth-child(1) {
 
  width:15%;
  white-space: nowrap;
}
#tab-drafts th:nth-child(2) {
width:15%;
  white-space: nowrap;
}
#tab-drafts th:nth-child(3) {
 
  width:25%;
  white-space: nowrap;
}
#tab-drafts th:nth-child(4) {
width:45%;
  white-space: nowrap;
}


/* My Requests */
#tab-myrequest th:nth-child(1) {

  width:10%;
  white-space: nowrap;
}
#tab-myrequest th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tab-myrequest th:nth-child(3) {
 
  width:20%;
  white-space: nowrap;
}
#tab-myrequest th:nth-child(4) {
width:20%;
  white-space: nowrap;
}
#tab-myrequest th:nth-child(5) {
 
  width:10%;
  white-space: nowrap;
}
#tab-myrequest th:nth-child(6) {
width:30%;
  white-space: nowrap;
}




/* My Reviews */
#tab-reviews th:nth-child(1) {

  width:10%;
  white-space: nowrap;
}
#tab-reviews th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tab-reviews th:nth-child(3) {
 
  width:10%;
  white-space: nowrap;
}
#tab-reviews th:nth-child(4) {
width:13%;
  white-space: nowrap;
}
#tab-reviews th:nth-child(5) {
 
  width:15%;
  white-space: nowrap;
}
#tab-reviews th:nth-child(6) {
width:12%;
  white-space: nowrap;
}
#tab-reviews th:nth-child(7) {
width:30%;
  white-space: nowrap;
}





/* My Actioned Request */
#tab-actioned th:nth-child(1) {

  width:10%;
  white-space: nowrap;
}
#tab-actioned th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tab-actioned th:nth-child(3) {
 
  width:10%;
  white-space: nowrap;
}
#tab-actioned th:nth-child(4) {
width:10%;
  white-space: nowrap;
}
#tab-actioned th:nth-child(5) {
 
  width:15%;
  white-space: nowrap;
}
#tab-actioned th:nth-child(6) {
width:10%;
  white-space: nowrap;
}
#tab-actioned th:nth-child(7) {
width:35%;
  white-space: nowrap;
}



/* All Requests */
#tab-allrequests th:nth-child(1) {

  width:10%;
  white-space: nowrap;
   
}
#tab-allrequests th:nth-child(2) {
width:10%;
  white-space: nowrap;
   
}
#tab-allrequests th:nth-child(3) {
 
  width:10%;
  white-space: nowrap;
   
}
#tab-allrequests th:nth-child(4) {
width:10%;
  white-space: nowrap;
    
}
#tab-allrequests th:nth-child(5) {
 
  width:10%;
  white-space: nowrap;
  
}
#tab-allrequests th:nth-child(6) {
width:10%;
  white-space: nowrap;
  
}
#tab-allrequests th:nth-child(7) {
 
  width:20%;
  white-space: nowrap;
   
}
#tab-allrequests th:nth-child(8) {
width:20%;
  white-space: nowrap;
  
}






                                                             /* Archived  Dashboard */
/* My Requests */
#tabid-myrequest th:nth-child(1) {

  width:10%;
  white-space: nowrap;
}
#tabid-myrequest th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tabid-myrequest th:nth-child(3) {
 
  width:20%;
  white-space: nowrap;
}
#tabid-myrequest th:nth-child(4) {
width:10%;
  white-space: nowrap;
}
#tabid-myrequest th:nth-child(5) {
 
  width:10%;
  white-space: nowrap;
}
#tabid-myrequest th:nth-child(6) {
width:40%;
  white-space: nowrap;
}

/* My Reviews */
#tabid-myreviews th:nth-child(1) {
    white-space: nowrap;
  width:10%
}
#tabid-myreviews th:nth-child(2) {
  width:10%;
  white-space: nowrap;
}
#tabid-myreviews th:nth-child(3) {
 
  width:20%;
  white-space: nowrap;
}
#tabid-myreviews th:nth-child(4) {
width:10%;
  white-space: nowrap;
}
#tabid-myreviews th:nth-child(5) {
 
  width:10%;
  white-space: nowrap;
}
#tabid-myreviews th:nth-child(6) {
width:40%;
  white-space: nowrap;
}



/* Archived -> My Actioned Request  */
#tabid-actioned th:nth-child(1) {

  width:10%;
  white-space: nowrap;
}
#tabid-actioned th:nth-child(2) {
width:10%;
  white-space: nowrap;
}
#tabid-actioned th:nth-child(3) {
 
  width:10%;
  white-space: nowrap;
}
#tabid-actioned th:nth-child(4) {
width:10%;
  white-space: nowrap;
}
#tabid-actioned th:nth-child(5) {
 
  width:15%;
  white-space: nowrap;
}
#tabid-actioned th:nth-child(6) {
width:10%;
  white-space: nowrap;
}
#tabid-actioned th:nth-child(7) {
width:35%;
  white-space: nowrap;
}



/*Archived ->  All Requests */
#tabid-allrequests th:nth-child(1) {

  width:10%;
  white-space: nowrap;
   
}
#tabid-allrequests th:nth-child(2) {
width:10%;
  white-space: nowrap;
   
}
#tabid-allrequests th:nth-child(3) {
 
  width:10%;
  white-space: nowrap;
   
}
#tabid-allrequests th:nth-child(4) {
width:10%;
  white-space: nowrap;
    
}
#tabid-allrequests th:nth-child(5) {
 
  width:10%;
  white-space: nowrap;
  
}
#tabid-allrequests th:nth-child(6) {
width:10%;
  white-space: nowrap;
  
}
#tabid-allrequests th:nth-child(7) {
 
  width:20%;
  white-space: nowrap;
   
}
#tabid-allrequests th:nth-child(8) {
width:20%;
  white-space: nowrap;
  
}

textarea.form-control:disabled {
    background-color: #f8f9fa !important; 
    border: #ffff !important;
}
body.modal-open[data-active-modal="unauthorized"] .modal-backdrop.show {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: rgb(91 91 91 / 75%);
  opacity: 1;
}

.form-check-input[type=checkbox]
 {
    border-radius: .25em;
    border: 2px solid #afafaf !important;
}
@media print {
  input[type="checkbox"][disabled] {
    opacity: 1 !important;
  }
}

select#entries-select-FILTER {
    width: 100%;
    font-size: 14px;
}

.tdTime{
    white-space: nowrap;
}

@media (max-width: 990px) {
.mt2top{
  margin-top: .5rem !important;

}
}
.form-control:disabled {
    background-color: #ffff !important; 
    opacity: 1;
}


.disabled-bggrey{
  background-color: var(--bs-secondary-bg) !important;
}
.pinkshade:disabled {
    background-color: var(--bs-secondary-bg);
    opacity: 1;
    background-color: #ffdedf !important;

}
.mainSubtypeDescParent{
      text-align: center;
    align-items: center;
    display: flex;
}
.subtypeDescChild{
  font-size: 14px;
    float: left;
    padding: 2px 11px;
    margin: 0px auto;
    font-weight: 600;
}

.excelCsvContainer{
      height: 30px;
    width: 30px;

}

.excelCsvContainer{
    gap: 20%;
    display: flex;
    justify-content: end;
}


table.dash tbody tr.odd {
    background-color: #fff;
}
table.dash tbody tr {
    background-color: #ffffff;
}
.rq_inf_box p.mar {
    font-size: 14px;
}
.no-attachments {
    font-size: 14px;
    font-weight: bold;
    color: #69727a;
}
.css-nalcay-control {
min-height: 42px !important;
margin-top: -1px !important;
}
.disClass .css-3iigni-container .css-16xfy0z-control{
    min-height: auto !important;
    height: 35px;
    background-color: #f2f2f2 !important;
}
.centerAlign{
  text-align: center !important;
}
.thPettyCash{
  font-size: 18px !important;
  text-align: center !important;
}
.amountsBorder {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    text-align: right !important;
    overflow-wrap: anywhere;   /*  key */
    word-break: break-word;
}
.selectnewclass{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.noteCls{
  font-size: 16px;
  font-style: italic;
  color: red;
  
}


.table-stripedpetty > tbody > tr:nth-of-type(odd) {
  --bs-table-striped-bg: #ffff;
}
.table-stripedpetty > tbody > tr.no-stripe {
    --bs-table-striped-bg: transparent !important;
    background-color: transparent !important;
}

.table-stripedpetty > tbody  > tr.no-hover:hover {
     --bs-table-striped-bg: transparent !important;
    background-color: transparent !important;
    --bs-table-hover-bg: rgba(0, 0, 0, 0.0);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"CAAC;EACC,SAAS;EACT,+CAA+C;EAC/C,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB,EAAE,mCAAmC;EACvD,aAAa;EACb,0BAA0B,EAAE,wCAAwC;EACpE,gBAAgB;AAClB;;;AAGA;EACE;kBACgB;EAChB,yDAAyD;EACzD,kBAAkB,EAAE,mCAAmC;EACvD,aAAa;EACb,0BAA0B,EAAE,wCAAwC;EACpE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,UAAU;;AAEZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,YAAY;EACZ,YAAY;IACV,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;EACvB;AACF;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,WAAW,EAAE,mCAAmC;EAChD,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,yDAAyD;EACzD,kBAAkB,GAAG,mCAAmC;EACxD,sBAAsB;EACtB,0BAA0B,EAAE,wCAAwC;EACpE,kBAAkB;MACd,8BAA8B;;EAElC,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;IACb,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;AAEF;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;GAEG,iCAAiC;EAClC,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA;;GAEG,6BAA6B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;;AAGA;AACA,yBAAyB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB,yBAAyB;AACzB;AACA;AACA,2BAA2B;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC,EAAE,uBAAuB;EAC7D,eAAe,EAAE,4BAA4B;AAC/C;AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;IACV,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,UAAU;EACV,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,YAAY,EAAE,6CAA6C;AAC7D;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;;AAGA;EACE,aAAa;IACX,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;;;AAIA;EACE,wBAAwB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;MACM,oBAAoB;IACtB,YAAY;AAChB;;AAEA;EACE,yBAAyB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,SAAS;IACP,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,WAAW;AACb;;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;IACd,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;KACK,YAAY;AACjB;AACA;MACM,4BAA4B;AAClC;AACA;MACM,uBAAuB;IACzB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;EACE,uBAAuB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;EACE,gBAAgB;IACd,gBAAgB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;;AAGA;QACQ,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd;IACJ;;AAEJ;QACQ,cAAc;QACd,uBAAuB;IAC3B;;;AAGJ;;;;GAIG;AACH;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;;EAGE,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;AACf;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;MACnB,eAAe;EACnB,kDAAkD;EAClD,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc,EAAE,6BAA6B;EAC7C,0BAA0B,EAAE,4BAA4B;AAC1D;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;EACE,8BAA8B;;AAEhC;AACA;EACE,4BAA4B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;;;;;;;;;;;;;;;;;GAiBG;AACH;;IAEI,SAAS;AACb;AACA;;EAEE,6BAA6B;AAC/B;AACA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;AACA;;;;;;;GAOG;AACH;EACE,uBAAuB;AACzB;AACA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;;;;;;GAMG;AACH;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;EACE,kCAAkC;AACpC;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,+BAA+B;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,kBAAkB;EAClB,SAAS;IACP,QAAQ;EACV,2BAA2B;EAC3B,WAAW;EACX,eAAe;;AAEjB;;AAEA;MACM,kBAAkB;IACpB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,WAAW;MACT,eAAe;;AAErB;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB,EAAE,oCAAoC;EACtD,kBAAkB;AACpB;;AAEA,6CAA6C;;AAE7C,iBAAiB,8BAA8B,EAAE;AACjD,sBAAsB,qCAAqC,EAAE;AAC7D,YAAY;AACZ;EACE;KACG,kBAAkB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;AACF,UAAU;EACR;;IAEE;IACA,UAAU;IACV,eAAe;;AAEnB;AACA,2BAA2B,sCAAsC,CAAC;;AAElE;;AAEA,QAAQ;AACR;;EAEE;GACC,eAAe;AAClB;;AAEA;;GAEG;AACH;EACE,WAAW;EACX,YAAY;AACd;AACA;;AAEA;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;;AAEA;AACA;AACA,aAAa;AACb;AACA;;AAEA,gBAAgB;AAChB;;EAEE;IACE,aAAa;AACjB;AACA;EACE,UAAU;AACZ;AACA;;GAEG;AACH;EACE,uBAAuB;AACzB;;AAEA;;GAEG;AACH;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;CACC,aAAa;AACd;AACA;EACE,aAAa;EACb,iCAAiC;CAClC;AACD;;;IAGI;CACH;;;IAGG;IACA;IACA,UAAU;IACV,eAAe;;AAEnB;AACA,2BAA2B,sCAAsC,CAAC;AAClE;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;AAEA;CACC;IACG,kBAAkB;IAClB,WAAW;AACf;IACI;MACE,+BAA+B;IACjC;IACA;IACA,UAAU;IACV,eAAe;;AAEnB;AACA,2BAA2B,sCAAsC,CAAC;AAClE;;AAEA;CACC;IACG,kBAAkB;IAClB,WAAW;AACf;IACI;MACE,8BAA8B;IAChC;IACA;IACA,UAAU;IACV,eAAe;;AAEnB;AACA,2BAA2B,sCAAsC,CAAC;AAClE;;AAEA;;;;;GAKG;AACH;;;;GAIG;;;AAGH;;EAEE;IACE,cAAc;EAChB;;EAEA;;KAEG;IACD;IACA,UAAU;IACV,eAAe;;AAEnB;AACA,2BAA2B,sCAAsC,CAAC;AAClE;;;AAGA;EACE;IACE,aAAa;AACjB;AACA,oBAAoB,UAAU,CAAC;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;;GAEG;AACH;;GAEG;AACH;;;GAGG;AACH;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;QACP,mBAAmB;QACnB,8BAA8B;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;IACI,+BAA+B;EACjC,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;CACd;CACA;EACC,aAAa;EACb,iCAAiC;CAClC;CACA;EACC,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;IACI;IACA,UAAU;IACV,eAAe;;AAEnB;AACA,2BAA2B,sCAAsC,CAAC;AAClE;;;;;;AAMA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB,EAAE,aAAa,EAAE;AACpC;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,gDAAgD;AACjE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;oBAEoB;;AAEpB;EACE;MACI,uBAAuB;EAC3B;;EAEA;MACI,yBAAyB;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,UAAU;AACZ;;;AAGA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;GAGG;CACF;EACC,kBAAkB;CACnB;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,2BAA2B;EAC3B,oCAAoC;CACrC;CACA;IACG,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;;AAEhB;CACC;EACC,uBAAuB;CACxB;CACA;EACC,sBAAsB;CACvB;CACA;IACG,2BAA2B;CAC9B;CACA;GACE,uBAAuB;CACzB;CACA;MACK,2BAA2B;IAC7B,8BAA8B;IAC9B,0BAA0B;CAC7B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,eAAe;CAChB;CACA;EACC,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;IACI,4RAA4R;IAC5R,cAAc;IACd,WAAW;IACX,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,mFAAmF;IACnF,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;IAC1B,2DAA2D;IAC3D,sCAAsC;IACtC,sEAAsE;MACpE,0BAA0B;;AAEhC;;AAEA;CACC,cAAc;IACX,WAAW;IACX,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,mFAAmF;IACnF,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;IAC1B,2DAA2D;IAC3D,sCAAsC;IACtC,sEAAsE;MACpE,0BAA0B;AAChC;AACA;EACE,oCAAoC;AACtC;;;CAGC,iCAAiC;AAClC,kCAAkC;;AAElC,eAAe,wBAAwB;AACvC;MACM,6BAA6B;IAC/B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA;EACE,4BAA4B;AAC9B;CACC;EACC,uBAAuB;CACxB;AACD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,cAAc;AAC/B;AACA;CACC,sBAAsB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,sBAAsB;IACpB,WAAW;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE;AACF;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B,EAAE,iBAAiB;EAChD,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;;;AAIA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,yCAAyC;AACzC;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;AACA,iCAAiC;AACjC;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;AACA;IACI,6BAA6B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;AACA;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;IACf,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;EACE,qBAAqB,EAAE,6BAA6B;EACpD,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;AACA,wCAAwC;AACxC;AACA;EACE,wBAAwB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,oCAAoC;QAChC,yBAAyB;QACzB,YAAY;AACpB;AACA;EACE,2BAA2B;IACzB,YAAY;IACZ,oCAAoC;AACxC;AACA;MACM,oCAAoC;MACpC,2BAA2B;AACjC;AACA;MACM,oCAAoC;AAC1C;AACA;EACE,mBAAmB;EACnB,eAAe;IACb,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA;GACG,aAAa;QACR,mBAAmB;QACnB,8BAA8B;QAC9B,qBAAqB;QACrB,QAAQ;QACR,YAAY;QACZ,wBAAwB;QACxB,mBAAmB;QACnB,eAAe;AACvB;AACA;GACG,aAAa;QACR,mBAAmB;QACnB,8BAA8B;QAC9B,qBAAqB;QACrB,QAAQ;QACR,kBAAkB;QAClB,wBAAwB;QACxB,mBAAmB;QACnB,qBAAqB;;AAE7B;AACA;EACE,oBAAoB;AACtB;AACA;IACI;SACK,eAAe;IACpB;;IAEA;IACA,WAAW;IACX,kBAAkB;AACtB;;AAEA;AACA;IACI;SACK,eAAe;IACpB;;IAEA;IACA,WAAW;IACX,kBAAkB;AACtB;;AAEA;;AAEA;IACI;SACK,eAAe;IACpB;;IAEA;IACA,WAAW;IACX,kBAAkB;AACtB;;AAEA;AACA;IACI;SACK,cAAc;IACnB;;IAEA;IACA,WAAW;IACX,kBAAkB;AACtB;;AAEA;AACA;AACA;;GAEG;AACH;AACA;;;GAGG;;AAEH;EACE,qBAAqB,EAAE,wCAAwC;AACjE;;AAEA;KACK,mCAAmC;IACpC,uCAAuC;EACzC,kBAAkB;AACpB;;AAEA;IACI;KACC,8BAA8B;IAC/B;;IAEA;;;GAGD;;AAEH;;;AAGA;IACI;IACA,WAAW;IACX,kBAAkB;AACtB;AACA,oBAAoB,UAAU,CAAC;AAC/B;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;EACE,WAAW;CACZ;;AAED;;AAEA;IACI;IACA,WAAW;IACX,kBAAkB;AACtB;AACA,oBAAoB,UAAU,CAAC;AAC/B;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,WAAW;CACZ;AACD;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;AAC1B;;;AAGA;AACA,6CAA6C;IACzC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,WAAW;CACZ;AACD;AACA,4CAA4C,cAAc,cAAc,EAAE;EACxE,WAAW;CACZ;;AAED;AACA;IACI;KACC,8BAA8B;IAC/B;IACA;MACE,kBAAkB;IACpB,WAAW;IACX;AACJ;;AAEA;AACA;AACA,kBAAkB;AAClB,WAAW;AACX;AACA;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;EACE,gCAAgC,EAAE,iCAAiC;EACnE,gBAAgB;AAClB;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,kBAAkB,EAAE,yBAAyB;EAC7C,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY,EAAE,iCAAiC;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;IACX,8BAA8B;AAClC;AACA;MACM,UAAU;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;;;AAIA;;;;;;;;;;GAUG;;AAEH;CACC;QACO,4BAA4B;CACnC;;AAED;AACA;CACC;QACO,4BAA4B;CACnC;AACD;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;CACC;;OAEM,0BAA0B;CAChC;AACD;;AAEA;EACE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA,qEAAqE;AACrE;EACE,4BAA4B;AAC9B;;AAEA,+EAA+E;AAC/E;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,+EAA+E;AAC/E;;GAEG;;AAEH;uDACuD;AACvD;EACE,+BAA+B;AACjC;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;;;;AAIA;;GAEG;;AAEH;EACE;KACG,YAAY;EACf,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV;EACA;IACE,oBAAoB;IACpB,WAAW;IACX,WAAW;AACf;;AAEA;AACA;EACE;IACE,kBAAkB;EACpB;;;AAGF;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO,EAAE,0BAA0B;EACnC,+BAA+B,EAAE,kCAAkC;AACrE;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,6BAA6B,IAAI,uCAAuC;AAC1E;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;AACA;GACG,2BAA2B;AAC9B;AACA,oBAAoB;AACpB;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;AAIA,iBAAiB;AACjB;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;CAIC,WAAW;AACZ;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;AAGA,gBAAgB;AAChB;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;;AAKA,eAAe;AACf;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;;;AAMA,wBAAwB;AACxB;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;AAIA,iBAAiB;AACjB;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;AACA;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;AACA;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;AACA;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;;;;;;;6DAO6D,wBAAwB;AACrF,gBAAgB;AAChB;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;AAEA,eAAe;AACf;IACI,mBAAmB;EACrB;AACF;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;AAIA,qCAAqC;AACrC;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;AACA;AACA,SAAS;EACP,mBAAmB;AACrB;;;;AAIA,6BAA6B;AAC7B;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;AACA;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;AACA;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;AACA;;EAEE,SAAS;EACT,mBAAmB;;AAErB;AACA;AACA,SAAS;EACP,mBAAmB;;AAErB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;AAC5B;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;IAEI,oBAAoB;IACpB,oCAAoC;AACxC;AACA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;AACA;EACE,4BAA4B;;AAE9B;AACA;AACA;IACI,kCAAkC;IAClC,UAAU;AACd;;;AAGA;EACE,mDAAmD;AACrD;AACA;IACI,wCAAwC;IACxC,UAAU;IACV,oCAAoC;;AAExC;AACA;MACM,kBAAkB;IACpB,mBAAmB;IACnB,aAAa;AACjB;AACA;EACE,eAAe;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;MACM,YAAY;IACd,WAAW;;AAEf;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,oBAAoB;AACxB;;;AAGA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;AACA,2BAA2B;AAC3B,2BAA2B;AAC3B;AACA;IACI,2BAA2B;IAC3B,YAAY;IACZ,oCAAoC;AACxC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,2DAA2D;IAC3D,sCAAsC;IACtC,4BAA4B;IAC5B,uBAAuB,IAAI,SAAS;IACpC,sBAAsB;AAC1B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;;AAEZ;;;AAGA;EACE,4BAA4B;AAC9B;AACA;IACI,6CAA6C;IAC7C,wCAAwC;AAC5C;;AAEA;KACK,6CAA6C;IAC9C,wCAAwC;IACxC,uCAAuC;AAC3C","sourcesContent":[" body {\r\n  margin: 0;\r\n  font-family: 'Open Sans', sans-serif !important;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  overflow: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n.layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n}\r\n.popup-textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n  resize: none;\r\n}\r\n.flexrows{\r\n  display: flex;\r\n    justify-content: space-between;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n}\r\n.popup-input {\r\n  width: 100%;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n  height: 10rem;\r\n}\r\n\r\n.header {\r\n  background: #ffffff;\r\n  color: rgb(5, 4, 4);\r\n  padding: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.main {\r\n  display: flex;\r\n  flex: 1;\r\n  margin-left: 250px; /* Match the width of the sidebar */\r\n  padding: 1rem;\r\n  height: calc(100vh - 60px); /* Full height minus top banner height */\r\n  overflow-y: auto;\r\n}\r\n \r\n\r\n.content {\r\n  /* flex: 1;\r\n  padding: 20px; */\r\n  /*margin-top: 60px;  Match the height of the top banner */\r\n  margin-left: 250px; /* Match the width of the sidebar */\r\n  padding: 1rem;\r\n  height: calc(100vh - 60px); /* Full height minus top banner height */\r\n  overflow-y: auto;\r\n}\r\n\r\n.sidebar {\r\n\r\n  height: 100vh;\r\n  position: fixed;\r\n  z-index: 1;\r\n \r\n}\r\n.back-to-list {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  cursor: pointer;\r\n}\r\n.custom-button {\r\n  padding: 15px 30px;\r\n  background-color: #5A9BD5;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 35px;\r\n  cursor: pointer;\r\n}\r\n.save-button {\r\n  padding: .375rem 25px;\r\n  background-color: #1A4D8F !important;\r\n  color: white;\r\n  border: none;\r\n    border-radius: 100px;\r\n    cursor: pointer !important;\r\n    height: 38px;\r\n    font-size: 16px;\r\n}\r\n.saveButton:hover {\r\n    color: #fff;\r\n    background-color: #0069d9;\r\n    border-color: #0062cc;\r\n  }\r\n.input-field {\r\n  height: 52px;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n}\r\n\r\n.back-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n/* Top Banner */\r\n.top-banner {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 250px; /* Match the width of the sidebar */\r\n  right: 0;\r\n  height: 60px;\r\n  z-index: 1000;\r\n}\r\n\r\n/* Content Area */\r\n.content-area {\r\n  /* margin-top: 15px; Match the height of the top banner */\r\n  margin-left: 270px;  /* Match the width of the sidebar */\r\n  padding: 2.5rem 1.7rem;\r\n  height: calc(100vh - 60px); /* Full height minus top banner height */\r\n  position: relative;\r\n      background: #fafafa !important;\r\n\r\n  /* overflow-y: auto; */\r\n}\r\n\r\n.subtypes {\r\n  padding: 20px;\r\n}\r\n\r\n.subtypes-header {\r\n  font-size: 20px;\r\n  margin-bottom: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.subtypes-container {\r\n  border: 1px solid #ccc;\r\n  padding: 20px 30px;\r\n  background-color: #fff;\r\n  margin: 20px 0px;\r\n  height:auto;\r\n  width: 100%;\r\n}\r\n\r\n.leftBorder {\r\n  font-size: 24px;\r\n    color: #323232;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    border-left: 3px solid #ED6C00;\r\n    padding: 0 0 0 5px;\r\n    line-height: 25px;\r\n  }\r\n\r\n  .headingbold {\r\n    font-weight: 700;\r\n    text-transform:none !important;\r\n  }\r\n\r\n.subtypes-title {\r\n  font-size: 20px;\r\n  margin-bottom: 10px;\r\n  font-weight: bold;\r\n  color: #000000;\r\n}\r\n\r\n.add-item-button {\r\n  float: right;\r\n  background-color: #fff;\r\n  color: #FF0000;\r\n  padding: 8px 12px;\r\n  border: 2px solid #FF0000;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  display: flex;\r\n}\r\n\r\n.add-item-button:hover {\r\n  background-color: #f4c2c2;\r\n}\r\n\r\n.subtypes-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 30px;\r\n  color: #1F5186;\r\n}\r\n\r\n.table-content {\r\n  /* width: 100%; */\r\n  border-collapse: collapse;\r\n  margin-top: 30px;\r\n  color: black;\r\n}\r\n.actionClass{\r\n  width: 12%;\r\n}\r\n.sett th,\r\n.sett td {\r\n   border: 1px solid #ccc !important; \r\n  /* text-align: justify;  */\r\n  padding: 14px 15px;\r\n}\r\n\r\n\r\n.table .table-striped th,\r\n.table .table-striped td {\r\n   /* border: 1px solid #ccc;  */\r\n  /* text-align: justify;  */\r\n  border: none !important;\r\n  padding: 14px 15px;\r\n}\r\n\r\n\r\n.table thead tr{\r\ncolor: #323232 !important;\r\n}\r\n\r\n.table tbody td{\r\n  font-size: 15px;\r\n  font-weight: 400;\r\ncolor: #323232 !important;\r\n}\r\n.subtypes-table th {\r\nfont-weight: 700 !important;\r\n}\r\n\r\n.subtypes-table th {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.subtypes-table.table-striped tbody tr:hover {\r\n  background-color: #e0f7fa !important; /* Override Bootstrap */\r\n  cursor: pointer; /* Optional: shows pointer */\r\n}\r\n.actions {\r\n  display: flex;\r\n  border: 1px;\r\n}\r\n\r\n.fontsize {\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n}\r\n\r\n.action-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  padding: 0 !important;\r\n}\r\n\r\n.action-btn:hover {\r\n  color: #007bff;\r\n}\r\n.centerAlign{\r\n  text-align: center !important;\r\n}\r\n.actionButtons{\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n}\r\n.actionIcons{\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n.actionIconsLt{\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n.ml-10{\r\n  margin-left: 10px;\r\n}\r\n.rightAligned{\r\n  text-align: right !important;\r\n}\r\n.withoutBorderButton{\r\n  border: none;\r\n    background: #ffff;\r\n    padding-left: 0px;\r\n}\r\n\r\n.logoset_main{\r\n  width:120px;\r\n}\r\n.logoset1{\r\n  width: 100%;\r\n}\r\n\r\n.leftside_hide{\r\n  display: none;\r\n}\r\n.search-btn {\r\n  background: #EEEEEE;\r\n  border: 1px solid #e0e0e0;\r\n  color: #323232;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  max-width: 100%;\r\n  margin: 0 0 0 20px;\r\n  box-shadow: none;\r\n  transition: all 0.2s ease-in-out;\r\n  font-family: inherit;\r\n}\r\n\r\n.search-btn:hover {\r\n  background-color: #ccc;\r\n  color: white;\r\n  border: 1px solid #054772;\r\n  cursor: pointer;\r\n}\r\n.search-button:hover {\r\n  border: 1px solid #ccc !important;\r\n}\r\n@media (min-width: 1450px ) {\r\n  .search-btn {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.search-bar.rightfloat {\r\n  /* width: 50%; */\r\n  float: right;\r\n}\r\n.rightfloat .form-control{\r\n  font-size: 12px !important;\r\n}\r\n.entries-selector {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n  font-size: 13px;\r\n}\r\n\r\nselect#entries-select {\r\n  width: 62px;\r\n  font-size: 14px;\r\n}\r\n.newselect select#entries-select {\r\n  flex: none;\r\n  width: 30%;\r\n  background-size: 14px 16px; \r\n}\r\n.newselect .form-select{\r\n  min-height: 38px !important;\r\n}\r\n.pagination-container {\r\n  text-align: center;\r\n}\r\n\r\n\r\n.pagination-btn {\r\n  padding: 5px 15px;\r\n  /* margin: 0 5px; */\r\n  border: 1px solid #ccc;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n}\r\n\r\n.pagination-btn.active {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n}\r\nbutton#pending-approval-search-btn {\r\n  font-weight: 700;\r\n}\r\n.pagination-btn:disabled {\r\n  cursor: not-allowed;\r\n  background-color: #e9ecef;\r\n  pointer-events: none;\r\n  opacity: 0.5; /* Optional: Makes the button look disabled */\r\n}\r\n.scroll{\r\n  overflow-y: auto;\r\n  padding-bottom: 25% !important;\r\n  scrollbar-color: #1f5186 #1f5186;\r\n}\r\n\r\n.loader-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 200px;\r\n}\r\n\r\n.loader {\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #3498db;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n\r\n.dflexcheckbox{\r\n  display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.dflexAdbUtoon{\r\n display: flex;\r\n gap: 5px; \r\n}\r\n\r\n\r\n\r\n.flexRequestTitle{\r\n  display: flex !important;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n\r\n.outerPlacehoder{\r\n  text-align: right;\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  color: #808080;\r\n}\r\n.alignright{\r\n      text-align-last: end;\r\n    float: right;\r\n}\r\n\r\n.approverPositions{\r\n  color: rgb(128, 128, 128);\r\n    text-align: left;\r\n    font-size: 10px;\r\n    font-weight: 400;\r\n}\r\n.attachmentList{\r\n  border: 0;\r\n    font-weight: bold;\r\n    background-color: #f9f9f987 !important;\r\n}\r\n\r\n.list-group-item:last-child {\r\n  margin-bottom: 0;\r\n  border-bottom-right-radius: .25rem;\r\n  border-bottom-left-radius: .25rem;\r\n}\r\n.list-group-item:first-child {\r\n  border-top-left-radius: .25rem;\r\n  border-top-right-radius: .25rem;\r\n}\r\n.floatLeft{\r\n  float: left;\r\n}\r\n\r\n\r\n.action-by {\r\n  font-weight: bold;\r\n}\r\n.subtext {\r\n  color: gray;\r\n  font-size: 12px;\r\n}\r\n.readValues{\r\n  text-align: left;\r\n    font-size: 14px !important;\r\n    color: #323232;\r\n    font-weight: 600;\r\n}\r\n.mar{\r\n  margin-bottom: 0px;\r\n  font-weight: 600;\r\n}\r\n.pspan{\r\n  color: rgb(128, 128, 128);\r\n  text-align: left;\r\n  font-weight: 400;\r\n  padding: 0px 0px 0px 12px;\r\n  font-size: 10px !important;\r\n  float: left;\r\n  width: 100%;;\r\n}\r\n\r\n.pspanread{\r\n  float: left;\r\n  width: 100%;;\r\n}\r\n\r\n.loader-container-req {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100vh; /* Full page loader */\r\n}\r\n\r\n.spinner-req {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 5px solid #f3f3f3;\r\n  border-top: 5px solid #3498db;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n/* .file-list {\r\n  margin-top: 10px;\r\n} */\r\n\r\n.bgBottom{\r\n  border-top: none !important;\r\n  border-bottom: 1px solid #ccc !important;\r\n}\r\n.imgIcon{\r\n  width: 100%;\r\n  float: left;\r\n}\r\n.imgModalH{\r\n     height: 15vh;\r\n}\r\n.bgRight{\r\n      border-right: 2px solid #ccc;\r\n}\r\n.fileNameModal{\r\n      padding: 5px !important;\r\n    font-size: 11px !important;\r\n    text-align: left;\r\n}\r\n.newModalButton{\r\n  padding: 8px !important;\r\n    font-size: 6px !important;\r\n    top: 3px !important;\r\n}\r\n.scrollModal{\r\n  overflow-y: auto;\r\n    max-height: 60vh;\r\n}\r\n.emailTypeLogo{\r\n  width: 92%;\r\n}\r\n.file-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  background: #F7F7F7;\r\n  padding: 6px 8px;\r\n  border-radius: 5px;\r\n  margin: 0px 0px 8px 0px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #ff585d;\r\n  cursor: pointer  !important;\r\n  /* max-width: 350px;  Fixed width */\r\n  /* overflow: hidden; */\r\n  /* white-space: nowrap; */\r\n  /* text-overflow: ellipsis; */\r\n  position: relative;\r\n  float:left;\r\n  margin-right: 10px;\r\n}\r\n\r\n\r\n.parentUpload .col-md-3{\r\n        flex: 0 0 auto;\r\n        /* width: 20% */\r\n    }\r\n\r\n    .parentUploadread .col-md-3{\r\n        flex: 0 0 auto;\r\n        width: 20%\r\n    }\r\n\r\n.parentUploadnew .col-md-4{\r\n        flex: 0 0 auto;\r\n        /* width: 25.333333%; */\r\n    }\r\n\r\n\r\n/* a.fileName.visited,\r\na.fileName.visited:visited {\r\n    color: #ff585d !important;\r\n    text-decoration: none !important;\r\n} */\r\na.fileName:visited {\r\n    color: #ff585d !important;\r\n    text-decoration: none !important;\r\n}\r\n\r\na.fileName:hover,\r\na.fileName:focus,\r\na.fileName:active {\r\n  color: #1564B7 !important;\r\n  /* text-decoration: underline !important; */\r\n  outline: none;\r\n}\r\na.fileName:hover{\r\n  text-decoration: underline !important;\r\n}\r\na.fileName{\r\n  color: #1564B7;\r\n  cursor: pointer  !important;\r\n  text-decoration: auto;\r\n  /* overflow: hidden; */\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n      font-size: 14px;\r\n  /* max-width: 180px;  Ensures the text truncates */\r\n  /* display: inline-block; */\r\n}\r\n.file-item:hover .tooltip {\r\n  display: block;\r\n}\r\n\r\n.tooltip {\r\n  display: none;\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 0;\r\n  background-color: #333;\r\n  color: #fff;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  z-index: 10;\r\n}\r\n.file-item:hover {\r\n  color: #1564B7;\r\n  outline: none;\r\n}\r\n.file-item:not([data-has-id=\"true\"]):hover {\r\n  color: #ff585d; /* Keeps default text color */\r\n  cursor: default !important; /* Prevents pointer cursor */\r\n}\r\n\r\n.removeButton {\r\n  background: #f7f7f7;\r\n  color: white;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 8px;\r\n}\r\n\r\n\r\nspan.chip.false.false {\r\n  background: rgb(230 230 230);\r\n  border-radius: 3px;\r\n  color: rgb(51 51 51);\r\n  height: 30px;\r\n}\r\nimg.icon_cancel.closeIcon {\r\n  filter: brightness(0.2) !important;\r\n}\r\n\r\nli.option.highlightOption.highlight {\r\n    background: #ffff !important;\r\n    color: #000 !important;\r\n}\r\nli.option.highlightOption.highlight:hover {\r\n  background: #accee4 !important;\r\n\r\n}\r\n.dotsDisable{\r\n  background: #ffff !important;\r\n    cursor: no-drop !important;\r\n    font-size: 12px;\r\n    color: #000;\r\n}\r\n\r\n.react-datepicker__header {\r\n    padding: 0px !important;\r\n    background-color: #fff !important;\r\n}\r\nh2.react-datepicker__current-month {\r\n    padding: 6px !important;\r\n    margin: 3px !important;\r\n    background: #f0f0f0 !important;\r\n    border-radius: 3px !important;\r\n    border: 1px solid #3333;\r\n}\r\n/* button.react-datepicker__navigation.react-datepicker__navigation--next {\r\n    background: grey;\r\n    border-radius: 50px;\r\n    width: 15px;\r\n    height: 15px;\r\n    position: absolute;\r\n    top: 11px;\r\n    right: 18px;\r\n}\r\nbutton.react-datepicker__navigation.react-datepicker__navigation--previous {\r\n    background: grey;\r\n    border-radius: 50px;\r\n    width: 15px;\r\n    height: 15px;\r\n    position: absolute;\r\n    top: 11px;\r\n    left: 18px;\r\n} */\r\nspan.react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous, \r\nspan.react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {\r\n    left: 0px;\r\n}\r\n.react-datepicker__navigation-icon::before, .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow{\r\n\r\n  border-color: #000 !important;\r\n}\r\n.react-datepicker__navigation-icon--previous, .react-datepicker__navigation-icon--next {\r\n    right: -3px !important;\r\n    top: 0px !important;\r\n}\r\n/* .react-datepicker__navigation-icon {\r\n    position: relative;\r\n    top: 3px;\r\n    font-size: 20px;\r\n    width: 22px;\r\n    background: #ff0000 !important;\r\n    border-radius: 50px !important;\r\n} */\r\n.react-datepicker__header{\r\n  border: none !important;\r\n}\r\n.react-datepicker__day--today {\r\n    border: 1px solid #dad55e !important;\r\n    background: #fffa90 !important;\r\n    /* color: #777620 !important; */\r\n    border-radius: 0px !important;\r\n}\r\n.react-datepicker__day--keyboard-selected {\r\n    border-radius: 0px !important;\r\n}\r\n/* .react-datepicker__day--keyboard-selected {\r\n    border: 1px solid #003eff !important;\r\n    background: #007fff !important;\r\n    font-weight: normal !important;\r\n    color: #ffffff !important;\r\n    border-radius: 0px !important;\r\n} */\r\n.react-datepicker__day {\r\n    border: 1px solid #c5c5c5;\r\n    background: #f6f6f6;\r\n    font-weight: normal;\r\n    color: #454545 ; \r\n    border-radius: 0px !important;\r\n    height: 25px;\r\n    width: 30px !important;\r\n    margin: 2px !important;\r\n}\r\n.react-datepicker__navigation-icon::before, .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow {\r\n    border-width: 2px 2px 0 0 !important; \r\n    height: 7px !important;\r\n    top: 8px !important;\r\n    width: 7px !important;\r\n}\r\n.react-datepicker__day-name {\r\n    font-weight: bold;\r\n    width: 29px !important;\r\n}\r\n.react-datepicker__month{\r\n  margin: 7px 2px 2px 2px !important;\r\n}\r\n.react-datepicker__day--outside-month, .react-datepicker__day--outside-month:hover{\r\n    color: white !important;\r\n    border: none !important;\r\n    background: none !important;\r\n    cursor: default;\r\n    pointer-events: none !important;\r\n}\r\n.adv-search-css {\r\n  color: #ff585d !important;\r\n}\r\n.adv-search-css:focus, .adv-search-css:hover, .adv-search-css:active {\r\n    color: #1564B7 !important;\r\n    outline: none;\r\n}\r\n.date-picker-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n}\r\n\r\n.date-input {\r\n  width: 100%;\r\n  padding-right: 35px; /* Make space for the icon */\r\n}\r\n\r\n.calendar-icon {\r\n  position: absolute;\r\n  right: 3%;\r\n    top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #555;\r\n  cursor: pointer;\r\n  \r\n}\r\n\r\n.calendar-iconnew{\r\n      position: absolute;\r\n    top: 45%;\r\n    right: 20px;\r\n    transform: translateY(-50%);\r\n    font-size: 20px;\r\n    color: #555;\r\n      cursor: pointer;\r\n\r\n}\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.fetch-loader-container {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.fetch-loader {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 3px solid rgba(0, 0, 0, 0.3);\r\n  border-top: 3px solid #007bff;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.cpunterLoader{\r\n  color: #ffff;\r\n  font-size: 10px;\r\n}\r\n.hh{\r\n  height: 32px;\r\n}\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.row.mt-3.overflowScroll {\r\n  overflow-x: auto;\r\n}\r\n.searchWrapper{\r\n  overflow-x: auto;\r\n}\r\n.form-check{\r\n  justify-content: center;\r\n  display: flex !important;\r\n  align-items: center;\r\n}\r\n\r\n.ql-container.ql-snow {\r\n  min-height: 100px;\r\n  resize: vertical;\r\n  overflow: auto;\r\n  font-size: 14px !important;\r\n  font-family: 'Open Sans', sans-serif !important;\r\n}\r\n\r\n#toolbar .ql-style::before {\r\n  content: \"\\2728\"; /* Unicode sparkle/magic wand icon */\r\n  padding-right: 4px;\r\n}\r\n\r\n/* Add similar CSS for each font you define */\r\n\r\n.ql-font-arial { font-family: Arial, sans-serif; }\r\n.ql-font-comic-sans { font-family: \"Comic Sans MS\", cursive; }\r\n/* desktop */\r\n@media screen and (min-device-width: 1024px) and (max-device-width: 1366px) { \r\n  .content-area {\r\n     margin-left: 270px; \r\n  }\r\n  .flexrowsRow1{\r\n    width: 25%;\r\n  }\r\n  .flexrowsRow2{\r\n    width: 21%;\r\n  }\r\n  .flexrowsRow3{\r\n    width: 20%;\r\n  }\r\n  .flexrowsRow15 {\r\nwidth: 10%;\r\n  }\r\n  \r\n    .calendar-iconnew{      \r\n    right: 5px;\r\n    font-size: 16px;\r\n\r\n}\r\n.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}\r\n\r\n}\r\n\r\n/* Tab */\r\n@media screen and (min-device-width: 767px) and (max-device-width: 1023px) { \r\n  \r\n  nav.navbar.navbar-expand-lg.navbar-light.bg-light.fixed-top .container-fluid h2 {\r\n   font-size: 16px;\r\n}\r\n\r\n/* .content-area {\r\n  margin-left: 70px !important;\r\n} */\r\n.emailTypeLogo{\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n}\r\n\r\n@media screen and (min-device-width: 1024px) and (max-device-width: 991px) { \r\n\r\n.emailTypeLogo{\r\n  width: 100px;\r\n  height: 100px;\r\n}\r\n}\r\n\r\n@media (max-width: 992px) {\r\n.emailTypeLogo{\r\ndisplay: none;\r\n}\r\n}\r\n\r\n/* mobile View */\r\n@media screen and (min-device-width: 481px) and (max-device-width: 991px) { \r\n  \r\n  nav.navbar.navbar-expand-lg.navbar-light.bg-light.fixed-top .container-fluid h2 {\r\n    display: none;\r\n}\r\n.actionClass{\r\n  width: 20%;\r\n}\r\n/* .sidebar {\r\n  width: 60px !important;\r\n} */\r\n.sidebar-expanded {\r\n  width: 240px !important;\r\n}\r\n\r\n/* .content-area {\r\n  margin-left: 70px !important;\r\n} */\r\ninput.inputType {\r\n  margin-bottom: 10px;\r\n}\r\n.saveButton, .save-button {\r\n  padding: 8px 20px;\r\n  font-size: 13px;\r\n}\r\n.cancelButton {\r\n  padding: 8px 20px;\r\n  font-size: 13px;\r\n}\r\n.dflexcheckbox{\r\n  display: block;\r\n}\r\n.emailTypeLogo{\r\n display: none;\r\n}\r\n.oneD{\r\n  display: flex;\r\n  flex-direction: column !important;\r\n }\r\n/* .onSmallScreen{\r\n  position: absolute;\r\n    right: 0px;\r\n } */\r\n /* .onSmallScreen{\r\n  position: absolute;\r\n    right: 0px;\r\n } */\r\n    .calendar-iconnew{      \r\n    right: 5px;\r\n    font-size: 16px;\r\n\r\n}\r\n.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}\r\n.BoxDeligate{\r\n  width: fit-content;\r\n  min-width: 170px !important;\r\n}\r\n\r\n}\r\n\r\n@media screen and (min-device-width: 763px) and (max-device-width: 991px) { \r\n button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    position: absolute;\r\n    right: 60px;\r\n}\r\n    .header-bg h1 {\r\n      padding-right: 100px !important;\r\n    }\r\n    .calendar-iconnew{      \r\n    right: 5px;\r\n    font-size: 16px;\r\n\r\n}\r\n.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}\r\n}\r\n\r\n@media screen and (min-device-width: 679px) and (max-device-width: 762px) { \r\n button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    position: absolute;\r\n    right: 60px;\r\n}\r\n    .header-bg h1 {\r\n      padding-right: 90px !important;\r\n    }\r\n    .calendar-iconnew{      \r\n    right: 5px;\r\n    font-size: 16px;\r\n\r\n}\r\n.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}\r\n}\r\n\r\n/* @media screen and (min-device-width: 751px) and (max-device-width: 991px) { \r\n button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    position: absolute;\r\n    right: 60px;\r\n}\r\n} */\r\n/* @media screen and (max-device-width: 1024px){\r\n.emailTypeLogo{\r\n display: none !important;\r\n}\r\n} */\r\n\r\n\r\n@media screen and (min-device-width: 320px) and (max-device-width: 1023px) { \r\n\r\n  .leftside_hide{\r\n    display: block;\r\n  }\r\n  \r\n  /* button.btn.btn-sm.btn-outline-light{\r\n    display: none;\r\n  } */\r\n    .calendar-iconnew{      \r\n    right: 5px;\r\n    font-size: 16px;\r\n\r\n}\r\n.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}\r\n}\r\n\r\n\r\n@media screen and (min-device-width: 130px) and (max-device-width: 469px) {\r\n  nav.navbar.navbar-expand-lg.navbar-light.bg-light.fixed-top .container-fluid h2 {\r\n    display: none;\r\n}\r\n.newResponsive .col{flex: auto;}\r\n.positionForXLSV{\r\n  position: absolute;\r\n  right: 60px;\r\n  top: 225px;\r\n  margin-top: 1px;\r\n}\r\n.positionForCSV{\r\n  position: absolute;\r\n  right: 30px;\r\n  top: 225px;\r\n  margin-top: 1px;\r\n}\r\n.searchsm{\r\n  height:31px;\r\n}\r\n.subtypes-container {\r\n  padding: 20px 20px !important;\r\n}\r\n/* .content-area {\r\n  margin-left: 70px !important;\r\n} */\r\n/* .subtypes-container { //in case of\r\n  width: 250px;\r\n} */\r\n/* button.add-item-button {\r\n  margin-left: 30px;\r\n  width: 100%;\r\n} */\r\n.rightfloat {\r\n  float: left;\r\n  margin-top: 12px;\r\n}\r\n\r\n.pagination-btn {\r\n  padding: 5px 10px;\r\n  margin: 0 2px;\r\n}\r\n\r\n.pagination-container.mt-4 {\r\n  font-size: 12px;\r\n  overflow-x: auto;\r\n}\r\n\r\ninput.inputType {\r\n  margin-bottom: 10px;\r\n}\r\n.saveButton, .save-button {\r\n  padding: 8px 20px;\r\n  font-size: 13px;\r\n}\r\n.cancelButton {\r\n  padding: 8px 20px;\r\n  font-size: 13px;\r\n}\r\n.dflexcheckbox{\r\n  display: flex;\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n}\r\n.fontTitle {\r\n  margin-top: 10px;\r\n}\r\n.disabled-btn {\r\n  cursor: not-allowed !important;\r\n  opacity: 0.6;\r\n  pointer-events: none;\r\n}\r\n.disabled-tab {\r\n  pointer-events: none;\r\n  opacity: 0.6;\r\n}\r\n\r\n.disabled-link {\r\n    pointer-events: none !important;\r\n  cursor: no-drop !important;\r\n}\r\n.disabled-tabs {\r\n  pointer-events: none;\r\n  opacity: 0.6;\r\n}\r\n.flexrowsRow1{\r\n  width: 100%;\r\n}\r\n.flexrowsRow2{\r\n  width: 100%;\r\n}\r\n.flexrowsRow3{\r\n  width: 100%;\r\n}\r\n.margin0Small{\r\n  margin:0 !important;\r\n}\r\n.flexrowsRow15{\r\n  margin-top: 20px;\r\n}\r\n.flexrowsRow4 {\r\n  margin-top: 20px;\r\n}\r\n.emailTypeLogo{\r\n  display: none;\r\n }\r\n .oneD{\r\n  display: flex;\r\n  flex-direction: column !important;\r\n }\r\n h6.text-3xl.font-bold {\r\n  font-size: 10px;\r\n}\r\nh5.text-3xl.font-bold {\r\n  font-size: 17px;\r\n}\r\n.d-lg-none{\r\n  position: absolute;\r\n    right: 0px;\r\n}\r\nbutton.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    position: absolute;\r\n    right: 30px;\r\n}\r\n    .calendar-iconnew{      \r\n    right: 5px;\r\n    font-size: 16px;\r\n\r\n}\r\n.formcntl-n .form-control{ padding: .375rem 1.6rem .375rem .25rem;}\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.no-records-container {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.no-records-image {\r\n  width: 150px;\r\n  height: auto;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.no-records-container p {\r\n  font-size: 16px;\r\n  color: #888;\r\n}\r\n.fileDownload{\r\n  cursor: \"pointer\"; width: \"24px\"; height: \"24px\" \r\n}\r\n\r\n.disabled-btn {\r\n  color: #888; /* Gray text color */\r\n  cursor: not-allowed; /* Change cursor to not-allowed */\r\n}\r\n\r\n.spinner-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(255, 255, 255, 0.6); /* Semi-transparent background */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999; /* Ensures it appears above all other elements */\r\n}\r\n\r\n.spinner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/*******************\\\r\n  Loading Roller\r\n\\*******************/\r\n\r\n@keyframes lds-roller {\r\n  0% {\r\n      transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n      transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.BoxDeligate{\r\n  width: fit-content;\r\n  min-width: 170px;\r\n}\r\n.lds-roller {\r\n  position: relative;\r\n  display: inline-block;\r\n  height: 64px;\r\n  width: 64px;\r\n}\r\n\r\n.lds-roller div {\r\n  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\r\n  transform-origin: 32px 32px;\r\n  position: absolute;\r\n}\r\n\r\n.lds-roller div:after {\r\n  position: absolute;\r\n  display: block;\r\n  background: #00539f;\r\n  border-radius: 50%;\r\n  content: \" \";\r\n  height: 6px;\r\n  width: 6px;\r\n}\r\n\r\n/* Adjust positions for child divs */\r\n.lds-roller div:nth-child(1) {\r\n  animation-delay: -0.036s;\r\n}\r\n.lds-roller div:nth-child(1):after {\r\n  top: 50px;\r\n  left: 50px;\r\n}\r\n\r\n.lds-roller div:nth-child(2) {\r\n  animation-delay: -0.072s;\r\n}\r\n.lds-roller div:nth-child(2):after {\r\n  top: 54px;\r\n  left: 45px;\r\n}\r\n\r\n.lds-roller div:nth-child(3) {\r\n  animation-delay: -0.108s;\r\n}\r\n.lds-roller div:nth-child(3):after {\r\n  top: 57px;\r\n  left: 39px;\r\n}\r\n\r\n.lds-roller div:nth-child(4) {\r\n  animation-delay: -0.144s;\r\n}\r\n.lds-roller div:nth-child(4):after {\r\n  top: 58px;\r\n  left: 32px;\r\n}\r\n\r\n.lds-roller div:nth-child(5) {\r\n  animation-delay: -0.18s;\r\n}\r\n.lds-roller div:nth-child(5):after {\r\n  top: 57px;\r\n  left: 25px;\r\n}\r\n\r\n.lds-roller div:nth-child(6) {\r\n  animation-delay: -0.216s;\r\n}\r\n.lds-roller div:nth-child(6):after {\r\n  top: 54px;\r\n  left: 19px;\r\n}\r\n\r\n.lds-roller div:nth-child(7) {\r\n  animation-delay: -0.252s;\r\n}\r\n.lds-roller div:nth-child(7):after {\r\n  top: 50px;\r\n  left: 14px;\r\n}\r\n\r\n.lds-roller div:nth-child(8) {\r\n  animation-delay: -0.288s;\r\n}\r\n.lds-roller div:nth-child(8):after {\r\n  top: 45px;\r\n  left: 10px;\r\n}\r\n\r\n\r\nbutton.navbar-toggler:hover {\r\n  border-color: #ff585d;\r\n  background-color: #ffdedf;\r\n  background-color: #ffdedf;\r\n  outline: none;\r\n}\r\n\r\nbutton.navbar-toggler:active {\r\n  border-color: #9678d3;\r\n  background-color: #ff585d;\r\n  background-color: #ff585d;\r\n}\r\n/* .\r\nm3t-container {\r\n  line-height: 2.5;\r\n} */\r\n .fitwidth{\r\n  width: fit-content;\r\n }\r\n .min180{\r\n  min-width: 180px !important;\r\n }\r\n .css-13cymwt-control {\r\n  min-height: 33px !important;\r\n  border: 1px solid #dee2e6 !important;\r\n }\r\n .noncheck .custom-select__control {\r\n    min-width: 170px !important;\r\n    min-height: 38px;\r\n    height: 38px;\r\n\r\n}\r\n .css-1xc3v61-indicatorContainer {\r\n  padding: 6px !important;\r\n }\r\n .css-19bb58m {\r\n  margin: 0px !important;\r\n }\r\n .css-t3ipsp-control{\r\n    min-height: 33px !important;\r\n }\r\n .css-15lsz6c-indicatorContainer{\r\n   padding: 6px !important;\r\n }\r\n .inTable{\r\n      padding-top: 0px !important;\r\n    padding-bottom: 0px !important;\r\n    font-size: 12px !important;\r\n }\r\n .css-1jqq78o-placeholder{\r\n  font-size: 14px !important;\r\n }\r\n .form-control{\r\n  font-size: 1rem;\r\n }\r\n .form-select{\r\n  font-size: 16px !important;\r\n  min-height: 33px !important;\r\n  background-size: 14px 16px;\r\n}\r\n.paddingleft{\r\n  padding: .75rem !important;\r\n}\r\n.form-selectnew {\r\n    /* --bs-form-select-bg-img: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e); */\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem 2.25rem .375rem .75rem !important;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: var(--bs-body-color);\r\n    -webkit-appearance: inline;\r\n    -moz-appearance: inline;\r\n    appearance: inline;\r\n    background-color: var(--bs-body-bg);\r\n    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\r\n    background-repeat: no-repeat;\r\n    background-position: right .75rem center;\r\n    background-size: 16px 12px;\r\n    border: var(--bs-border-width) solid var(--bs-border-color);\r\n    border-radius: var(--bs-border-radius);\r\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n      background-size: 14px 16px;\r\n\r\n}\r\n\r\n.form-selectnew1 {\r\n display: block;\r\n    width: 100%;\r\n    padding: .375rem 1.25rem .375rem .75rem !important;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: var(--bs-body-color);\r\n    -webkit-appearance: inline;\r\n    -moz-appearance: inline;\r\n    appearance: inline;\r\n    background-color: var(--bs-body-bg);\r\n    background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\r\n    background-repeat: no-repeat;\r\n    background-position: right .75rem center;\r\n    background-size: 16px 12px;\r\n    border: var(--bs-border-width) solid var(--bs-border-color);\r\n    border-radius: var(--bs-border-radius);\r\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n      background-size: 14px 16px;\r\n}\r\n.borderBlack{\r\n  border: 1px solid #000000 !important;\r\n}\r\n\r\n\r\n .pinkshade .css-3iigni-container{}\r\n.BoxDeligate .css-1r977u7-control{}\r\n\r\n::placeholder{ color:#717171 !important}\r\n.newRow{\r\n      background-color: transparent;\r\n    font-size: 12px;\r\n    border: 1px solid #ff0000;\r\n    border-radius: 4px;\r\n    color: #ff0000;\r\n}\r\n.lefty{\r\n  float: left;\r\n  margin-right: 15px;\r\n  white-space: nowrap;\r\n}\r\n.fields-table tr td input[type=\"number\"]::-webkit-outer-spin-button,\r\n.fields-table tr td input[type=\"number\"]::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n.fields-table tr td input,select,textarea{\r\n  padding-left: 1px !important;\r\n}\r\n .bgTable{\r\n  border: 1px solid #cccc;\r\n }\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999; /* very high */\r\n}\r\n.react-datepicker-wrapper {\r\n width: 100% !important;\r\n}\r\n.modal-content {\r\n  background: white;\r\n  padding: 20px 30px;\r\n  border-radius: 8px;\r\n  max-width: 600px;\r\n  width: 90%;\r\n  text-align: center;\r\n}\r\n.modal-overlay {\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to   { opacity: 1; }\r\n}\r\n.excRate{\r\n  float: left !important;\r\n    width: 100%;\r\n}\r\n.exRight{\r\n  float: right !important; \r\n}\r\n.exLeft{\r\n  margin-left:10px\r\n}\r\n.excRateflex{\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n.exTableLoad{\r\n  margin-left: 20%\r\n}\r\n\r\n.loader-container-excel {\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.excel-loader {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 2px solid #ccc;\r\n  border-top: 2px solid #007bff; /* blue spinner */\r\n  border-radius: 50%;\r\n  animation: spin 0.6s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.table.fields-table {\r\n  table-layout: fixed;\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n\r\n\r\n/* Resizer handle styling */\r\n.rc-handle-container {\r\n  position: relative;\r\n}\r\n\r\n.rc-handle {\r\n  position: absolute;\r\n  width: 7px;\r\n  cursor: col-resize;\r\n  z-index: 10;\r\n}\r\n\r\n.rc-handle:hover {\r\n  background-color: #007bff;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* Make sure table cells don't overflow */\r\n.table.fields-table td,\r\n.table.fields-table th {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.table.vm td {\r\nvertical-align: middle !important;\r\n}\r\n\r\n.table-responsive{\r\n  overflow: hidden ;\r\n  position: 'relative'\r\n}\r\n\r\n@media (max-width: 768px ) {\r\n.table.fields-table {\r\n    table-layout: auto !important;\r\n}\r\n\r\n.table-responsive{\r\n  overflow: auto !important;\r\n}\r\n}\r\n.cursorPointer{\r\n  cursor: pointer;\r\n}\r\n.withoutborder{\r\n  border: 0 !important;\r\n}\r\n.totalsValue{\r\n  text-align: right;\r\n    margin: 5px;\r\n}\r\n.table.fields-table td input[type=\"number\"] {\r\n    text-align: right;\r\n    padding-right: 5px;\r\n}\r\n\r\n.mt-30em{\r\n    margin-top: 0.3rem !important;\r\n}\r\n\r\n.select__option {\r\n  white-space: pre-wrap; /* preserves \\n line breaks */\r\n  line-height: 1.2;\r\n}\r\n\r\n.select__option::after {\r\n  font-size: 4px;\r\n  color: #666;\r\n}\r\n.selectedBadge{\r\n  line-height: 20px;\r\n}\r\n.select__multi-value, .css-a7jxaq-multiValue {\r\nbackground-color: transparent !important;\r\n}\r\n.css-1wy0on6{\r\n  display: none !important;\r\n}\r\n\r\n\r\n.css-3iigni-container{\r\n    border-radius: 4px;\r\n    background-color: #ffffff !important;\r\n        border: 1px solid #ced4da;\r\n        padding: 0px;\r\n}\r\n.css-16xfy0z-control{\r\n  min-height: auto !important;\r\n    height: 35px;\r\n    background-color: #ffdedf !important;\r\n}\r\n.css-snjzhi-control{\r\n      border: 3px solid #ffffff !important;\r\n      min-width: 180px !important;\r\n}\r\n.css-snjzhi-control_0{\r\n      border: 0px solid #ffffff !important;\r\n}\r\n.customDropdown{\r\n  color: rgb(0, 0, 0);\r\n  font-size: 14px;\r\n    font-weight: 400;\r\n    background-color: #cccccc !important;\r\n    text-align: left;\r\n    border-radius: 15px;\r\n}\r\n.select__multi-value__remove{\r\n    display: none !important;\r\n}\r\n.listingNameDiv{\r\n   display: flex;\r\n        align-items: center;\r\n        background: rgb(204, 204, 204);\r\n        border-radius: 9999px;\r\n        gap: 8px;\r\n        z-index: 100;\r\n        padding: 2px 5px 2px 2px;\r\n        align-items: center;\r\n        flex-wrap: wrap;\r\n}\r\n.listingNameDivOutOfOffice{\r\n   display: flex;\r\n        align-items: center;\r\n        background: rgb(204, 204, 204);\r\n        border-radius: 9999px;\r\n        gap: 8px;\r\n        /* z-index: 100; */\r\n        padding:2px 5px -1px 2px;\r\n        align-items: center;\r\n        /* flex-wrap: wrap; */\r\n\r\n}\r\n.css-1mkvw8y{\r\n  margin: 0 !important;\r\n}\r\n@media screen and (min-device-width: 990px) and (max-device-width: 1111px) { \r\n    .listingNameDiv {\r\n         font-size: 11px;\r\n    }\r\n\r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    right: 25px;\r\n    position: relative;\r\n}\r\n\r\n}\r\n@media screen and (min-device-width: 990px) and (max-device-width: 1111px) { \r\n    .listingNameDivOutOfOffice {\r\n         font-size: 10px;\r\n    }\r\n\r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    right: 25px;\r\n    position: relative;\r\n}\r\n\r\n}\r\n\r\n@media screen and (min-device-width: 768px) and (max-device-width: 1286px) { \r\n    .listingNameDivOutOfOffice {\r\n         font-size: 10px;\r\n    }\r\n\r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    right: 25px;\r\n    position: relative;\r\n}\r\n\r\n}\r\n@media screen and (min-device-width: 991px) and (max-device-width: 1190px) { \r\n    .listingNameDivOutOfOffice {\r\n         font-size: 6px;\r\n    }\r\n\r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    right: 25px;\r\n    position: relative;\r\n}\r\n\r\n}\r\n@media (max-width: 991px ) {\r\n/* .dashboard-header{\r\n    display: inline-block !important;\r\n} */\r\n}\r\n/* .select__input-container.css-19bb58m {\r\n    height: 0px;\r\n    padding-top: 0px;\r\n} */\r\n\r\n.badge-name:hover {\r\n  color: rgb(26, 0, 93); /* Example: Change text color on hover */\r\n}\r\n\r\n.badge-clear:hover {\r\n     color: rgb(255, 158, 27) !important;\r\n    background: rgb(255, 88, 93) !important;\r\n  border-radius: 50%;\r\n}\r\n\r\n@media screen and (min-device-width: 453px) and (max-device-width: 582px) { \r\n    .header-bg h1 {\r\n     padding-right: 20px !important;\r\n    }\r\n\r\n    /* button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    right: 25px;\r\n    position: relative;\r\n} */\r\n\r\n}\r\n\r\n\r\n@media screen and (min-device-width: 453px) and (max-device-width: 477px) { \r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    left: 250px;\r\n    position: relative;\r\n}\r\n.newResponsive .col{flex: auto;}\r\n.BoxDeligate {\r\n    width: fit-content;\r\n    min-width: 100%;\r\n}\r\n.fitwidth{\r\n  width: auto;\r\n }\r\n\r\n}\r\n\r\n@media screen and (min-device-width: 478px) and (max-device-width: 487px) { \r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n    left: 250px;\r\n    position: relative;\r\n}\r\n.newResponsive .col{flex: auto;}\r\n.BoxDeligate {\r\n    width: fit-content;\r\n    min-width: 100%;\r\n}\r\n\r\n.fitwidth{\r\n  width: auto;\r\n }\r\n}\r\n\r\n@media screen and (min-device-width: 451px) and (max-device-width: 950px) { \r\n  .navbar-menu-wrapper.d-flex.align-items-center.hamburger.onSmallerOnly {\r\n    /* position: relative; */\r\n    right: 50px !important;\r\n}\r\n\r\n\r\n}\r\n@media screen and (max-device-width: 450px){ .BoxDeligate {\r\n    width: fit-content;\r\n    min-width: 100%;\r\n}\r\n\r\n.fitwidth{\r\n  width: auto;\r\n }\r\n}\r\n@media screen and (max-device-width: 575px){.BoxDeligate {min-width:100%} .fitwidth{\r\n  width: auto;\r\n }\r\n\r\n}\r\n@media screen and (min-device-width: 583px) and (max-device-width: 762px) { \r\n    .header-bg h1 {\r\n     padding-right: 90px !important;\r\n    }\r\n    button.navbar-toggler.navbar-toggler.align-self-center.d-lg-none.onSmallerOnlyButton {\r\n      position: relative;\r\n    right: 50px;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n.navbar.default-layout .navbar-menu-wrapper {\r\nposition: relative;\r\nright: 50px;\r\n}\r\n}\r\n\r\n.dashboard-header.flex {\r\n    DISPLAY: FLEX;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1px;\r\n}\r\n.basic-single-select.active-underline .select__control {\r\n  border-bottom: 2px solid #007bff; /* Your desired underline color */\r\n  border-radius: 0;\r\n}\r\n\r\n.css-9x5mqu {\r\n    padding: 2px 10px !important;\r\n    font-size: 12px !important;\r\n}\r\n.basic-single-select .select__control {\r\n  box-shadow: none !important;\r\n  border-color: #ccc !important;\r\n}\r\n.basic-single-select .select__control {\r\n  cursor: pointer;\r\n  border-radius: 4px; /* Your existing radius */\r\n  font-size: 14px;\r\n}\r\n\r\n.select__option--is-focused {\r\n  background-color: rgb(255, 88, 93) !important;\r\n  color: #000;\r\n}\r\n\r\n.basic-single-select.active-underline .select__control {\r\n  border-bottom: 2px solid #007bff;\r\n  border-radius: 0;\r\n}\r\n.uploadButton:disabled {\r\n  cursor: no-drop;\r\n  opacity: 0.6; /* Optional for visual feedback */\r\n}\r\n.uploadButton{\r\n  max-height: 40px;\r\n}\r\n.textalignRight{\r\n  text-align: right !important;\r\n}\r\n\r\n.resizable-quill .ql-editor {\r\n  min-height: 150px;\r\n  /* max-height: 500px; */\r\n  resize: vertical;\r\n  overflow: auto;\r\n}\r\n\r\n.readValues img {\r\n  /* width: 100%; */\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n}\r\n\r\n.flexjsutify{\r\n  display: flex;\r\n    justify-content: space-between;\r\n}\r\n.descriptiontexterror{\r\n      color: red;\r\n}\r\n\r\n.noDataAlign{\r\n  text-align: center !important;\r\n}\r\n\r\n\r\n\r\n/* @media (max-width: 768px ) {\r\n.fileListMB3{\r\n  margin-bottom: 1rem !important;\r\n}\r\n}\r\n\r\n@media screen and (min-device-width: 769px) and (max-device-width: 1200px) { \r\n  .fileListMT2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n} */\r\n\r\n@media (min-width: 1400px) {\r\n .advInsider{\r\n        max-width: 1140px !important;\r\n }\r\n\r\n}\r\n@media (min-width: 1200px) {\r\n .advInsider{\r\n        max-width: 1140px !important;\r\n }\r\n}\r\n\r\n.row.mt-3.mb-3.parentUploadnew {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    width: 100%;\r\n}\r\n\r\n.fileListMB3 {\r\n    width: auto !important;\r\n    float: left;\r\n    display: flex;\r\n}\r\n\r\n.file-list.fileListMT2.pl-0 {\r\n    width: 70%;\r\n    float: left;\r\n}\r\n\r\n@media (max-width: 690px) {\r\n .row.mt-3.mb-3.parentUploadnew{\r\n\r\n       flex-wrap: wrap !important;\r\n }\r\n}\r\n\r\n@media (max-width: 690px) {\r\n  .fileListMT2 {\r\n    margin-top: 1rem !important;\r\n    margin-left: 10px !important;\r\n  }\r\n} \r\n\r\n/* 1) Make the control allow overflow (so native tooltips can show) */\r\n.custom-select__control {\r\n  overflow: visible !important;\r\n}\r\n\r\n/* 2) Put single‑value and input into their own columns so they don’t overlap */\r\n.custom-select__value-container--has-value {\r\n  display: grid !important;\r\n  grid-template-columns: auto 1fr auto !important;\r\n  align-items: center !important;\r\n}\r\n\r\n/* 3) Place your badge in column #1 */\r\n.custom-select__single-value {\r\n  grid-area: 1 / 1 / 2 / 2 !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n/* 4) Push the input into column #2 so it no longer sits on top of your badge */\r\n/* .custom-select__input-container {\r\n  grid-area: 1 / 2 / 2 / 3 !important;\r\n} */\r\n\r\n/* 5) (Optional) make the input click‑through when not focused,\r\n      so badge clicks still go to the control wrapper */\r\n.custom-select__input-container:not(:focus-within) {\r\n  pointer-events: none !important;\r\n}\r\n\r\n\r\n.headingsReadable h6{\r\n  font-size: 0.67em !important;\r\n}\r\n\r\n.headingsReadable h5{\r\n  font-size: 0.83em !important;\r\n}\r\n\r\n.headingsReadable h4{\r\n  font-size: 1em !important;\r\n}\r\n\r\n.headingsReadable h3{\r\n  font-size: 1.17em !important;\r\n}\r\n.headingsReadable h2{\r\n  font-size: 1.5em !important;\r\n}\r\n.headingsReadable h1{\r\n  font-size: 2em !important;\r\n}\r\n\r\n\r\n\r\n/* html, body {\r\n\r\n} */\r\n\r\n@media (max-width: 980px) {\r\n  html, body {\r\n     height: 100%;\r\n  margin: 0;\r\n  min-width: 980px !important;\r\n  padding: 0;\r\n  }\r\n  .mainStartPanel {\r\n    margin-bottom: 100px;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n}\r\n@media (min-width: 980px) {\r\n  .subtypes-table td {\r\n    padding: 10px 15px;\r\n  }\r\n  \r\n \r\n}\r\nbody {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.main-content {\r\n  flex: 1; /* Take remaining height */\r\n  min-height: calc(100vh - 100px); /* Adjust based on header/footer */\r\n}\r\n.table-responsive {\r\n  width: 100%;\r\n}\r\n\r\n.subtypes-table {\r\n  width: 100% !important;\r\n  table-layout: auto !important;   /* or fixed if you want equal columns */\r\n}\r\n\r\n.padStriped{\r\n  padding: 15px 10px 15px 10px !important;\r\n}\r\n.table-striped > tbody > tr:nth-of-type(odd) {\r\n  --bs-table-striped-bg: #f9f9f9;\r\n}\r\n\r\n.subtypes-table thead, .subtypes-table tbody {\r\n  width: 100%;\r\n}\r\ntable.dataTable.row-border > tbody > tr > th, table.dataTable.row-border > tbody > tr > td, table.dataTable.display > tbody > tr > th, table.dataTable.display > tbody > tr > td {\r\n   border-top: none !important; \r\n}\r\n/* table headewidth*/\r\n#tab-pending-approvals th:nth-child(1) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-pending-approvals th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-pending-approvals th:nth-child(3) {\r\n \r\n  width:20%;\r\n  white-space: nowrap;\r\n}\r\n#tab-pending-approvals th:nth-child(4) {\r\nwidth:20%;\r\n  white-space: nowrap;\r\n}\r\n#tab-pending-approvals th:nth-child(5) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-pending-approvals th:nth-child(6) {\r\nwidth:30%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n/* Resubmission */\r\n#tab-resubmission th:nth-child(1) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-resubmission th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-resubmission th:nth-child(3) {\r\n \r\n  width:15%;\r\n  white-space: nowrap;\r\n}\r\n#tab-resubmission th:nth-child(4) {\r\nwidth:15%;\r\n  white-space: nowrap;\r\n}\r\n#tab-resubmission th:nth-child(5) {\r\nwidth:30%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n /* Drafts */\r\n#tab-drafts th:nth-child(1) {\r\n \r\n  width:15%;\r\n  white-space: nowrap;\r\n}\r\n#tab-drafts th:nth-child(2) {\r\nwidth:15%;\r\n  white-space: nowrap;\r\n}\r\n#tab-drafts th:nth-child(3) {\r\n \r\n  width:25%;\r\n  white-space: nowrap;\r\n}\r\n#tab-drafts th:nth-child(4) {\r\nwidth:45%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n/* My Requests */\r\n#tab-myrequest th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-myrequest th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-myrequest th:nth-child(3) {\r\n \r\n  width:20%;\r\n  white-space: nowrap;\r\n}\r\n#tab-myrequest th:nth-child(4) {\r\nwidth:20%;\r\n  white-space: nowrap;\r\n}\r\n#tab-myrequest th:nth-child(5) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-myrequest th:nth-child(6) {\r\nwidth:30%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n\r\n/* My Reviews */\r\n#tab-reviews th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-reviews th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-reviews th:nth-child(3) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-reviews th:nth-child(4) {\r\nwidth:13%;\r\n  white-space: nowrap;\r\n}\r\n#tab-reviews th:nth-child(5) {\r\n \r\n  width:15%;\r\n  white-space: nowrap;\r\n}\r\n#tab-reviews th:nth-child(6) {\r\nwidth:12%;\r\n  white-space: nowrap;\r\n}\r\n#tab-reviews th:nth-child(7) {\r\nwidth:30%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* My Actioned Request */\r\n#tab-actioned th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-actioned th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-actioned th:nth-child(3) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-actioned th:nth-child(4) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-actioned th:nth-child(5) {\r\n \r\n  width:15%;\r\n  white-space: nowrap;\r\n}\r\n#tab-actioned th:nth-child(6) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tab-actioned th:nth-child(7) {\r\nwidth:35%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n/* All Requests */\r\n#tab-allrequests th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tab-allrequests th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tab-allrequests th:nth-child(3) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tab-allrequests th:nth-child(4) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n    \r\n}\r\n#tab-allrequests th:nth-child(5) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n  \r\n}\r\n#tab-allrequests th:nth-child(6) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n  \r\n}\r\n#tab-allrequests th:nth-child(7) {\r\n \r\n  width:20%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tab-allrequests th:nth-child(8) {\r\nwidth:20%;\r\n  white-space: nowrap;\r\n  \r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n                                                             /* Archived  Dashboard */\r\n/* My Requests */\r\n#tabid-myrequest th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myrequest th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myrequest th:nth-child(3) {\r\n \r\n  width:20%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myrequest th:nth-child(4) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myrequest th:nth-child(5) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myrequest th:nth-child(6) {\r\nwidth:40%;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* My Reviews */\r\n#tabid-myreviews th:nth-child(1) {\r\n    white-space: nowrap;\r\n  width:10%\r\n}\r\n#tabid-myreviews th:nth-child(2) {\r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myreviews th:nth-child(3) {\r\n \r\n  width:20%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myreviews th:nth-child(4) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myreviews th:nth-child(5) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-myreviews th:nth-child(6) {\r\nwidth:40%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n/* Archived -> My Actioned Request  */\r\n#tabid-actioned th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-actioned th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-actioned th:nth-child(3) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-actioned th:nth-child(4) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-actioned th:nth-child(5) {\r\n \r\n  width:15%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-actioned th:nth-child(6) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n}\r\n#tabid-actioned th:nth-child(7) {\r\nwidth:35%;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n/*Archived ->  All Requests */\r\n#tabid-allrequests th:nth-child(1) {\r\n\r\n  width:10%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tabid-allrequests th:nth-child(2) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tabid-allrequests th:nth-child(3) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tabid-allrequests th:nth-child(4) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n    \r\n}\r\n#tabid-allrequests th:nth-child(5) {\r\n \r\n  width:10%;\r\n  white-space: nowrap;\r\n  \r\n}\r\n#tabid-allrequests th:nth-child(6) {\r\nwidth:10%;\r\n  white-space: nowrap;\r\n  \r\n}\r\n#tabid-allrequests th:nth-child(7) {\r\n \r\n  width:20%;\r\n  white-space: nowrap;\r\n   \r\n}\r\n#tabid-allrequests th:nth-child(8) {\r\nwidth:20%;\r\n  white-space: nowrap;\r\n  \r\n}\r\n\r\ntextarea.form-control:disabled {\r\n    background-color: #f8f9fa !important; \r\n    border: #ffff !important;\r\n}\r\nbody.modal-open[data-active-modal=\"unauthorized\"] .modal-backdrop.show {\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  background-color: rgb(91 91 91 / 75%);\r\n  opacity: 1;\r\n}\r\n\r\n.form-check-input[type=checkbox]\r\n {\r\n    border-radius: .25em;\r\n    border: 2px solid #afafaf !important;\r\n}\r\n@media print {\r\n  input[type=\"checkbox\"][disabled] {\r\n    opacity: 1 !important;\r\n  }\r\n}\r\n\r\nselect#entries-select-FILTER {\r\n    width: 100%;\r\n    font-size: 14px;\r\n}\r\n\r\n.tdTime{\r\n    white-space: nowrap;\r\n}\r\n\r\n@media (max-width: 990px) {\r\n.mt2top{\r\n  margin-top: .5rem !important;\r\n\r\n}\r\n}\r\n.form-control:disabled {\r\n    background-color: #ffff !important; \r\n    opacity: 1;\r\n}\r\n\r\n\r\n.disabled-bggrey{\r\n  background-color: var(--bs-secondary-bg) !important;\r\n}\r\n.pinkshade:disabled {\r\n    background-color: var(--bs-secondary-bg);\r\n    opacity: 1;\r\n    background-color: #ffdedf !important;\r\n\r\n}\r\n.mainSubtypeDescParent{\r\n      text-align: center;\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n.subtypeDescChild{\r\n  font-size: 14px;\r\n    float: left;\r\n    padding: 2px 11px;\r\n    margin: 0px auto;\r\n    font-weight: 600;\r\n}\r\n\r\n.excelCsvContainer{\r\n      height: 30px;\r\n    width: 30px;\r\n\r\n}\r\n\r\n.excelCsvContainer{\r\n    gap: 20%;\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n\r\ntable.dash tbody tr.odd {\r\n    background-color: #fff;\r\n}\r\ntable.dash tbody tr {\r\n    background-color: #ffffff;\r\n}\r\n.rq_inf_box p.mar {\r\n    font-size: 14px;\r\n}\r\n.no-attachments {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: #69727a;\r\n}\r\n.css-nalcay-control {\r\nmin-height: 42px !important;\r\nmargin-top: -1px !important;\r\n}\r\n.disClass .css-3iigni-container .css-16xfy0z-control{\r\n    min-height: auto !important;\r\n    height: 35px;\r\n    background-color: #f2f2f2 !important;\r\n}\r\n.centerAlign{\r\n  text-align: center !important;\r\n}\r\n.thPettyCash{\r\n  font-size: 18px !important;\r\n  text-align: center !important;\r\n}\r\n.amountsBorder {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n    border: var(--bs-border-width) solid var(--bs-border-color);\r\n    border-radius: var(--bs-border-radius);\r\n    text-align: right !important;\r\n    overflow-wrap: anywhere;   /*  key */\r\n    word-break: break-word;\r\n}\r\n.selectnewclass{\r\n  padding-left: 0px !important;\r\n  padding-right: 0px !important;\r\n}\r\n.noteCls{\r\n  font-size: 16px;\r\n  font-style: italic;\r\n  color: red;\r\n  \r\n}\r\n\r\n\r\n.table-stripedpetty > tbody > tr:nth-of-type(odd) {\r\n  --bs-table-striped-bg: #ffff;\r\n}\r\n.table-stripedpetty > tbody > tr.no-stripe {\r\n    --bs-table-striped-bg: transparent !important;\r\n    background-color: transparent !important;\r\n}\r\n\r\n.table-stripedpetty > tbody  > tr.no-hover:hover {\r\n     --bs-table-striped-bg: transparent !important;\r\n    background-color: transparent !important;\r\n    --bs-table-hover-bg: rgba(0, 0, 0, 0.0);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
